// The pop-up collection: paper cards that open on a table and unfold in 3D
// (components/invite/PopupCard.tsx). Generated from design-mockups/popup-invites
// by build_registry.py; the artwork lives in public/templates/popup/<id>/.

import type { PaintedDef } from './paintedInvite'

export const POPUP_DEFS: PaintedDef[] = [
  {
    id: 'pop-jungle',
    look: 'popup',
    category: 'kids',
    label: { en: 'Jungle Party', ka: 'ჯუნგლების წვეულება' },
    blurb: { en: 'Animals and a birthday cake rise out of the card one layer at a time.', ka: 'ცხოველები და ტორტი ბარათიდან ფენა-ფენა ამოდის.' },
    tags: ['jungle', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#eef3e2',
    ink: '#3a2412',
    accents: ['#2f5d1e', '#2f6b45'],
    popup: {
      bh: 132.7,
      table: ['#eef3e2', '#c9ddbe'],
      floor: '#f7f1de',
      dot: 'rgba(106,168,79,.28)',
      edge: '#e6dbbe',
      cover: '#2f6b45',
      coverInk: '#fff7e6',
      plaque: '#d28e43',
      titleSize: 0.14,
      titleWeight: 700,
      layers: [
        { key: 'p1', iw: 494, ih: 811, x: 21, y: 10, w: 40, lean: 6 },
        { key: 'p2', iw: 529, ih: 801, x: 79, y: 12, w: 42, lean: 6 },
        { key: 'p0', iw: 913, ih: 648, x: 50, y: 36, w: 76, lean: 4 },
        { key: 'p3', iw: 846, ih: 345, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 557, ih: 454, x: 50, y: 92, w: 70, lean: 16, plaque: [0.21, 0.26, 0.21, 0.24] },
      ],
      floaters: [
        { key: 'p5', iw: 338, ih: 492, x: 13, top: 16, w: 20, z: 14, anim: 'bob' },
        { key: 'p6', iw: 226, ih: 217, x: 72, top: 48, w: 10, z: 36, anim: 'flutter' },
      ],
      thumbText: { left: 33.99, top: 71.7, width: 32.03, height: 13.35 },
    },
  },
  {
    id: 'pop-unicorn',
    look: 'popup',
    category: 'kids',
    label: { en: 'Unicorn Castle', ka: 'ერთრქას ციხესიმაგრე' },
    blurb: { en: 'A pastel castle and a baby unicorn, for the most requested girls theme.', ka: 'პასტელის ციხესიმაგრე და პატარა ერთრქა, გოგონების ყველაზე მოთხოვნადი თემისთვის.' },
    tags: ['unicorn', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#fdf0f4',
    ink: '#7a2448',
    accents: ['#c2386f', '#f5c3d6'],
    popup: {
      bh: 132.7,
      table: ['#fdf0f4', '#f1cfdf'],
      floor: '#fff6f8',
      dot: 'rgba(240,150,185,.30)',
      edge: '#f3dce4',
      cover: '#f5c3d6',
      coverInk: '#7a2448',
      plaque: '#fbd0d7',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p1', iw: 548, ih: 809, x: 50, y: 6, w: 50, lean: 6 },
        { key: 'p2', iw: 667, ih: 753, x: 81, y: 24, w: 38, lean: 5 },
        { key: 'p0', iw: 721, ih: 662, x: 29, y: 36, w: 56, lean: 4 },
        { key: 'p3', iw: 803, ih: 242, x: 50, y: 62, w: 106, lean: 2 },
        { key: 'p4', iw: 544, ih: 365, x: 50, y: 92, w: 74, lean: 16, plaque: [0.12, 0.31, 0.12, 0.13] },
      ],
      floaters: [
        { key: 'p5', iw: 306, ih: 492, x: 13, top: 18, w: 18, z: 14, anim: 'bob' },
        { key: 'p6', iw: 176, ih: 171, x: 86, top: 10, w: 9, z: 10, anim: 'twinkle' },
        { key: 'p6', iw: 176, ih: 171, x: 64, top: 34, w: 6, z: 22, anim: 'twinkle' },
      ],
      thumbText: { left: 27.96, top: 75.48, width: 44.08, height: 12.85 },
    },
  },
  {
    id: 'pop-capybara',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Capybara Spa', ka: 'კაპიბარების სპა' },
    blurb: { en: 'The trendy, funny one: capybaras on a spa day, for any age.', ka: 'ტრენდული და სასაცილო: კაპიბარები სპაში, ნებისმიერი ასაკისთვის.' },
    tags: ['capybara', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#fff1de',
    ink: '#3b2414',
    accents: ['#1f5f5b', '#ee8a3c'],
    popup: {
      bh: 132.7,
      table: ['#fff1de', '#f4cfa6'],
      floor: '#fff5e6',
      dot: 'rgba(242,155,69,.30)',
      edge: '#f1e0c6',
      cover: '#ee8a3c',
      coverInk: '#fffaf2',
      plaque: '#d29351',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p2', iw: 555, ih: 726, x: 21, y: 10, w: 40, lean: 6 },
        { key: 'p1', iw: 350, ih: 680, x: 83, y: 14, w: 26, lean: 6 },
        { key: 'p0', iw: 825, ih: 597, x: 50, y: 38, w: 78, lean: 4 },
        { key: 'p3', iw: 900, ih: 248, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 235, ih: 312, x: 86, y: 82, w: 13, lean: 4 },
        { key: 'p5', iw: 395, ih: 501, x: 50, y: 94, w: 50, lean: 16, plaque: [0.15, 0.37, 0.15, 0.09] },
      ],
      floaters: [
        { key: 'p6', iw: 407, ih: 559, x: 85, top: 14, w: 22, z: 12, anim: 'bob' },
      ],
      thumbText: { left: 36.16, top: 73.49, width: 27.68, height: 15.94 },
    },
  },
  {
    id: 'pop-rose',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Rose Garden', ka: 'ვარდების ბაღი' },
    blurb: { en: 'Classic paper-craft wedding: a rose arch, an urn of peonies and a pair of doves.', ka: 'კლასიკური ქაღალდის ქორწილი: ვარდების თაღი, პიონები და მტრედები.' },
    tags: ['rose', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#f6f0e8',
    ink: '#4f4032',
    accents: ['#8a6a3a', '#efe5d8'],
    popup: {
      bh: 132.7,
      table: ['#f6f0e8', '#e6d8ca'],
      floor: '#fbf7f1',
      dot: 'rgba(200,160,140,.22)',
      edge: '#ede3d6',
      cover: '#efe5d8',
      coverInk: '#6b5a45',
      plaque: '#f6ede3',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 813, ih: 882, x: 50, y: 12, w: 76, lean: 6 },
        { key: 'p1', iw: 542, ih: 776, x: 15, y: 34, w: 30, lean: 5 },
        { key: 'p2', iw: 292, ih: 834, x: 87, y: 30, w: 15, lean: 5 },
        { key: 'p3', iw: 892, ih: 345, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p6', iw: 266, ih: 196, x: 87, y: 86, w: 13, lean: 6 },
        { key: 'p4', iw: 426, ih: 523, x: 50, y: 93, w: 52, lean: 16, plaque: [0.2, 0.27, 0.2, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 630, ih: 446, x: 50, top: 8, w: 44, z: 22, anim: 'glide' },
      ],
      thumbText: { left: 37.62, top: 69.94, width: 24.76, height: 15.61 },
    },
  },
  {
    id: 'pop-tbilisi',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Old Tbilisi', ka: 'ძველი თბილისი' },
    blurb: { en: 'A Georgian wedding with a toast, carved balconies, grapevines and churchkhela.', ka: 'ქართული ქორწილი სადღეგრძელოთი, ხის აივნებით, ვაზით და ჩურჩხელით.' },
    tags: ['tbilisi', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#f6e9df',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#7b2232'],
    popup: {
      bh: 132.7,
      table: ['#f6e9df', '#e2c4b2'],
      floor: '#fbf2e8',
      dot: 'rgba(142,43,58,.18)',
      edge: '#eedccb',
      cover: '#7b2232',
      coverInk: '#fbeedd',
      plaque: '#a45c2b',
      lightText: true,
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p1', iw: 420, ih: 837, x: 15, y: 8, w: 30, lean: 6 },
        { key: 'p2', iw: 530, ih: 754, x: 83, y: 10, w: 34, lean: 6 },
        { key: 'p0', iw: 631, ih: 616, x: 50, y: 34, w: 58, lean: 4 },
        { key: 'p4', iw: 276, ih: 273, x: 16, y: 80, w: 14, lean: 6 },
        { key: 'p5', iw: 587, ih: 414, x: 50, y: 92, w: 70, lean: 16, plaque: [0.19, 0.22, 0.19, 0.22] },
      ],
      floaters: [
        { key: 'p3', iw: 800, ih: 322, x: 50, top: -1, w: 104, z: 8, anim: 'swing' },
        { key: 'p6', iw: 423, ih: 572, x: 86, top: 44, w: 21, z: 14, anim: 'bob' },
      ],
      thumbText: { left: 32.93, top: 73.47, width: 34.14, height: 12.87 },
    },
  },
  {
    id: 'pop-space',
    look: 'popup',
    category: 'kids',
    label: { en: 'Space Adventure', ka: 'კოსმოსური თავგადასავალი' },
    blurb: { en: 'A rocket, a moon and a kid astronaut rise out of the card.', ka: 'რაკეტა, მთვარე და პატარა ასტრონავტი ბარათიდან ამოდიან.' },
    tags: ['space', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#e8eef5',
    ink: '#1f3557',
    accents: ['#b8381f', '#1f3557'],
    popup: {
      bh: 134,
      table: ['#e8eef5', '#b7c6d9'],
      floor: '#f3f5f8',
      dot: 'rgba(60,110,170,.22)',
      edge: '#e2e7ee',
      cover: '#1f3557',
      coverInk: '#f4f7ff',
      plaque: '#d5e9f7',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p1', iw: 529, ih: 840, x: 19, y: 10, w: 32, lean: 6 },
        { key: 'p2', iw: 578, ih: 678, x: 81, y: 14, w: 36, lean: 6 },
        { key: 'p0', iw: 1065, ih: 716, x: 50, y: 38, w: 74, lean: 4 },
        { key: 'p3', iw: 1100, ih: 277, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p6', iw: 594, ih: 594, x: 50, y: 93, w: 54, lean: 16, plaque: [0.19, 0.24, 0.19, 0.22] },
      ],
      floaters: [
        { key: 'p7', iw: 366, ih: 266, x: 64, top: 12, w: 16, z: 10, anim: 'glide' },
        { key: 'p4', iw: 441, ih: 287, x: 84, top: 46, w: 22, z: 16, anim: 'bob' },
        { key: 'p8', iw: 225, ih: 229, x: 15, top: 30, w: 11, z: 12, anim: 'bob' },
        { key: 'p5', iw: 247, ih: 251, x: 30, top: 54, w: 8, z: 24, anim: 'bob' },
      ],
      thumbText: { left: 36.78, top: 72.61, width: 26.45, height: 13.63 },
    },
  },
  {
    id: 'pop-dino-party',
    look: 'popup',
    category: 'kids',
    label: { en: 'Dino Party', ka: 'დინოზავრების წვეულება' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['dino', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#eff2ea',
    ink: '#271e16',
    accents: ['#793f0c', '#508c0d'],
    popup: {
      bh: 134,
      table: ['#eff2ea', '#d6decc'],
      floor: '#f8f7f1',
      dot: 'rgba(118,200,28,.24)',
      edge: '#e9e8e2',
      cover: '#508c0d',
      coverInk: '#fff8ee',
      plaque: '#ccbdac',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 503, ih: 685, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 643, ih: 531, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 920, ih: 666, x: 50, y: 37, w: 74.6, lean: 4 },
        { key: 'p3', iw: 981, ih: 331, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 529, ih: 414, x: 50, y: 93, w: 63.9, lean: 16, plaque: [0.18, 0.21, 0.2, 0.28] },
      ],
      floaters: [
        { key: 'p5', iw: 361, ih: 487, x: 14, top: 18, w: 18.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 213, ih: 266, x: 86, top: 22, w: 9.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.02, top: 73.28, width: 31.01, height: 12.07 },
    },
  },
  {
    id: 'pop-pirate-island',
    look: 'popup',
    category: 'kids',
    label: { en: 'Pirate Island', ka: 'მეკობრეების კუნძული' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['pirate', 'island', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#eaeaed',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c490d'],
    popup: {
      bh: 134,
      table: ['#eaeaed', '#cacad2'],
      floor: '#f6f4f2',
      dot: 'rgba(200,109,28,.24)',
      edge: '#e8e6e3',
      cover: '#8c490d',
      coverInk: '#fff8ee',
      plaque: '#c3976e',
      lightText: true,
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 579, ih: 674, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 555, ih: 681, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 769, ih: 652, x: 50, y: 37, w: 63.7, lean: 4 },
        { key: 'p3', iw: 759, ih: 303, x: 50, y: 64, w: 70.1, lean: 2 },
        { key: 'p4', iw: 503, ih: 346, x: 50, y: 93, w: 72.7, lean: 16, plaque: [0.16, 0.21, 0.17, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 379, ih: 478, x: 14, top: 18, w: 19.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 253, ih: 312, x: 86, top: 22, w: 9.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.33, top: 73.25, width: 38.66, height: 13.19 },
    },
  },
  {
    id: 'pop-mermaid-lagoon',
    look: 'popup',
    category: 'kids',
    label: { en: 'Mermaid Lagoon', ka: 'ქალთევზების ლაგუნა' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['mermaid', 'lagoon', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#edf8f8',
    ink: '#27161b',
    accents: ['#0a5e66', '#0d878c'],
    popup: {
      bh: 134,
      table: ['#edf8f8', '#d1eced'],
      floor: '#f7f8f5',
      dot: 'rgba(28,194,200,.24)',
      edge: '#e8e9e6',
      cover: '#0d878c',
      coverInk: '#fff8ee',
      plaque: '#e4d1d6',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 599, ih: 607, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 565, ih: 583, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1025, ih: 524, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 930, ih: 410, x: 50, y: 64, w: 63.5, lean: 2 },
        { key: 'p4', iw: 444, ih: 463, x: 50, y: 93, w: 47.9, lean: 16, plaque: [0.22, 0.18, 0.16, 0.39] },
      ],
      floaters: [
        { key: 'p5', iw: 414, ih: 501, x: 14, top: 18, w: 20, z: 12, anim: 'bob' },
        { key: 'p6', iw: 338, ih: 374, x: 86, top: 22, w: 10.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 39.37, top: 72.68, width: 23.49, height: 10.15 },
    },
  },
  {
    id: 'pop-farm-friends',
    look: 'popup',
    category: 'kids',
    label: { en: 'Farm Friends', ka: 'ფერმის მეგობრები' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['farm', 'friends', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f0f2e6',
    ink: '#241c19',
    accents: ['#8c560d', '#828c0d'],
    popup: {
      bh: 134,
      table: ['#f0f2e6', '#d9dfc0'],
      floor: '#f8f7f0',
      dot: 'rgba(187,200,28,.24)',
      edge: '#e9e8e1',
      cover: '#828c0d',
      coverInk: '#fff8ee',
      plaque: '#ebe5e4',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 425, ih: 632, x: 20, y: 10, w: 40.3, lean: 6 },
        { key: 'p1', iw: 619, ih: 581, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 974, ih: 616, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 991, ih: 334, x: 50, y: 64, w: 83.1, lean: 2 },
        { key: 'p4', iw: 552, ih: 574, x: 50, y: 93, w: 48.1, lean: 16, plaque: [0.15, 0.18, 0.15, 0.43] },
      ],
      floaters: [
        { key: 'p5', iw: 366, ih: 560, x: 14, top: 18, w: 17.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 207, ih: 315, x: 86, top: 22, w: 8.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 36.74, top: 72.58, width: 26.52, height: 9.14 },
    },
  },
  {
    id: 'pop-construction-crew',
    look: 'popup',
    category: 'kids',
    label: { en: 'Construction Crew', ka: 'მშენებლები' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['construction', 'crew', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#f0efe8',
    ink: '#33240a',
    accents: ['#8c650d', '#8c490d'],
    popup: {
      bh: 134,
      table: ['#f0efe8', '#dbd8c6'],
      floor: '#f8f6f0',
      dot: 'rgba(200,109,28,.24)',
      edge: '#e9e7e2',
      cover: '#8c490d',
      coverInk: '#fff8ee',
      plaque: '#f7eedf',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 490, ih: 661, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 605, ih: 523, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1044, ih: 654, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 775, ih: 309, x: 50, y: 64, w: 70.2, lean: 2 },
        { key: 'p4', iw: 676, ih: 468, x: 50, y: 93, w: 72.2, lean: 16, plaque: [0.16, 0.2, 0.16, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 370, ih: 568, x: 14, top: 18, w: 17.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 341, ih: 272, x: 86, top: 22, w: 12.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.63, top: 73.19, width: 38.57, height: 13.89 },
    },
  },
  {
    id: 'pop-race-day',
    look: 'popup',
    category: 'kids',
    label: { en: 'Race Day', ka: 'რბოლის დღე' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['race', 'day', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#e9f0e8',
    ink: '#21211d',
    accents: ['#8c630d', '#0d608c'],
    popup: {
      bh: 134,
      table: ['#e9f0e8', '#c8dbc5'],
      floor: '#f6f6f0',
      dot: 'rgba(28,141,200,.24)',
      edge: '#e7e8e2',
      cover: '#0d608c',
      coverInk: '#fff8ee',
      plaque: '#f7f7f5',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 419, ih: 575, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 406, ih: 489, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 800, ih: 531, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 641, ih: 299, x: 50, y: 64, w: 60, lean: 2 },
        { key: 'p4', iw: 463, ih: 300, x: 50, y: 93, w: 76, lean: 16, plaque: [0.2, 0.27, 0.2, 0.27] },
      ],
      floaters: [
        { key: 'p5', iw: 341, ih: 437, x: 14, top: 18, w: 19.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 271, ih: 284, x: 86, top: 22, w: 10.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 32.12, top: 74.92, width: 35.58, height: 10.72 },
    },
  },
  {
    id: 'pop-fairy-garden',
    look: 'popup',
    category: 'kids',
    label: { en: 'Fairy Garden', ka: 'ფერიების ბაღი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['fairy', 'garden', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f0eeef',
    ink: '#331e0b',
    accents: ['#8c3d0d', '#8c820d'],
    popup: {
      bh: 134,
      table: ['#f0eeef', '#dad4d6'],
      floor: '#f8f6f2',
      dot: 'rgba(200,187,28,.24)',
      edge: '#e9e7e4',
      cover: '#8c820d',
      coverInk: '#fff8ee',
      plaque: '#e6c29f',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 591, ih: 730, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 666, ih: 561, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 810, ih: 709, x: 50, y: 37, w: 61.7, lean: 4 },
        { key: 'p3', iw: 871, ih: 382, x: 50, y: 64, w: 63.8, lean: 2 },
        { key: 'p4', iw: 580, ih: 425, x: 50, y: 93, w: 68.2, lean: 16, plaque: [0.21, 0.28, 0.21, 0.26] },
      ],
      floaters: [
        { key: 'p5', iw: 350, ih: 422, x: 14, top: 18, w: 20, z: 12, anim: 'bob' },
        { key: 'p6', iw: 240, ih: 195, x: 86, top: 22, w: 12.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.55, top: 74.95, width: 31.01, height: 10.87 },
    },
  },
  {
    id: 'pop-snow-princess',
    look: 'popup',
    category: 'kids',
    label: { en: 'Snow Princess', ka: 'თოვლის პრინცესა' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['snow', 'princess', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f5f7fb',
    ink: '#11202d',
    accents: ['#0d5b8c', '#0d5a8c'],
    popup: {
      bh: 134,
      table: ['#f5f7fb', '#e6ecf4'],
      floor: '#f9f8f5',
      dot: 'rgba(28,133,200,.24)',
      edge: '#eae9e7',
      cover: '#0d5a8c',
      coverInk: '#fff8ee',
      plaque: '#eaf0f6',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 566, ih: 683, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 625, ih: 689, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 897, ih: 589, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 939, ih: 259, x: 50, y: 64, w: 101.5, lean: 2 },
        { key: 'p4', iw: 504, ih: 567, x: 50, y: 93, w: 50.2, lean: 16, plaque: [0.2, 0.17, 0.2, 0.48] },
      ],
      floaters: [
        { key: 'p5', iw: 423, ih: 619, x: 14, top: 18, w: 18.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 214, ih: 239, x: 86, top: 22, w: 10.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.21, top: 69.94, width: 23.82, height: 9.29 },
    },
  },
  {
    id: 'pop-super-kid',
    look: 'popup',
    category: 'kids',
    label: { en: 'Super Kid', ka: 'სუპერ ბავშვი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['super', 'kid', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#f1f1e5',
    ink: '#2f2f0e',
    accents: ['#8c170d', '#8c680d'],
    popup: {
      bh: 134,
      table: ['#f1f1e5', '#dcddbf'],
      floor: '#f8f7f0',
      dot: 'rgba(200,151,28,.24)',
      edge: '#e9e8e1',
      cover: '#8c680d',
      coverInk: '#fff8ee',
      plaque: '#fefefc',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 429, ih: 800, x: 20, y: 10, w: 32.2, lean: 6 },
        { key: 'p1', iw: 537, ih: 660, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1025, ih: 790, x: 50, y: 37, w: 70.1, lean: 4 },
        { key: 'p3', iw: 1019, ih: 444, x: 50, y: 64, w: 64.3, lean: 2 },
        { key: 'p4', iw: 580, ih: 446, x: 50, y: 93, w: 65, lean: 16, plaque: [0.18, 0.19, 0.18, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 379, ih: 539, x: 14, top: 18, w: 18.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 204, ih: 304, x: 86, top: 22, w: 9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.43, top: 72.95, width: 32.89, height: 14.17 },
    },
  },
  {
    id: 'pop-puppy-party',
    look: 'popup',
    category: 'kids',
    label: { en: 'Puppy Party', ka: 'ლეკვების წვეულება' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['puppy', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#edf3e8',
    ink: '#352208',
    accents: ['#8c480d', '#0d6a8c'],
    popup: {
      bh: 134,
      table: ['#edf3e8', '#d2e2c5'],
      floor: '#f7f7f0',
      dot: 'rgba(28,154,200,.24)',
      edge: '#e8e8e2',
      cover: '#0d6a8c',
      coverInk: '#fff8ee',
      plaque: '#f5e3cc',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 456, ih: 483, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 358, ih: 457, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 698, ih: 529, x: 50, y: 37, w: 71.3, lean: 4 },
        { key: 'p3', iw: 892, ih: 206, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 536, ih: 276, x: 50, y: 93, w: 76, lean: 16, plaque: [0.15, 0.22, 0.16, 0.28] },
      ],
      floaters: [
        { key: 'p5', iw: 382, ih: 545, x: 14, top: 18, w: 18.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 215, ih: 218, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.41, top: 77.59, width: 40.95, height: 9.13 },
    },
  },
  {
    id: 'pop-kitty-cafe',
    look: 'popup',
    category: 'kids',
    label: { en: 'Kitty Café', ka: 'კნუტების კაფე' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['kitty', 'cafe', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f9f5f3',
    ink: '#3d3d00',
    accents: ['#8c440d', '#8c3a0d'],
    popup: {
      bh: 134,
      table: ['#f9f5f3', '#f1e7e0'],
      floor: '#fbf8f3',
      dot: 'rgba(200,89,28,.24)',
      edge: '#ece9e5',
      cover: '#8c3a0d',
      coverInk: '#fff8ee',
      plaque: '#fffffd',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 486, ih: 716, x: 20, y: 10, w: 40.7, lean: 6 },
        { key: 'p1', iw: 545, ih: 681, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1042, ih: 656, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 926, ih: 265, x: 50, y: 64, w: 97.8, lean: 2 },
        { key: 'p4', iw: 436, ih: 371, x: 50, y: 93, w: 58.8, lean: 16, plaque: [0.16, 0.27, 0.16, 0.17] },
      ],
      floaters: [
        { key: 'p5', iw: 470, ih: 632, x: 14, top: 18, w: 19, z: 12, anim: 'bob' },
        { key: 'p6', iw: 292, ih: 287, x: 86, top: 22, w: 11.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.31, top: 74.7, width: 31.38, height: 13.02 },
    },
  },
  {
    id: 'pop-penguin-pals',
    look: 'popup',
    category: 'kids',
    label: { en: 'Penguin Pals', ka: 'პინგვინები' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['penguin', 'pals', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#f1f8fc',
    ink: '#0d2230',
    accents: ['#0d628c', '#0d578c'],
    popup: {
      bh: 134,
      table: ['#f1f8fc', '#dbeef7'],
      floor: '#f8f8f6',
      dot: 'rgba(28,128,200,.24)',
      edge: '#e9eae7',
      cover: '#0d578c',
      coverInk: '#fff8ee',
      plaque: '#d2e3f0',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 767, ih: 529, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 345, ih: 554, x: 80, y: 13, w: 37.4, lean: 6 },
        { key: 'p2', iw: 961, ih: 515, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 967, ih: 291, x: 50, y: 64, w: 93, lean: 2 },
        { key: 'p4', iw: 454, ih: 321, x: 50, y: 93, w: 70.7, lean: 16, plaque: [0.13, 0.17, 0.13, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 344, ih: 497, x: 14, top: 18, w: 18.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 302, ih: 266, x: 86, top: 22, w: 11.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.11, top: 72.33, width: 41.46, height: 14.82 },
    },
  },
  {
    id: 'pop-under-the-sea',
    look: 'popup',
    category: 'kids',
    label: { en: 'Under the Sea', ka: 'ზღვის სიღრმეში' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['under', 'the', 'sea', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#d0dfe6',
    ink: '#1f1f1f',
    accents: ['#8c410d', '#0d5c8c'],
    popup: {
      bh: 134,
      table: ['#d0dfe6', '#8ab0c1'],
      floor: '#eff2f0',
      dot: 'rgba(28,136,200,.24)',
      edge: '#e1e3e1',
      cover: '#0d5c8c',
      coverInk: '#fff8ee',
      plaque: '#fefefe',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 490, ih: 766, x: 20, y: 10, w: 38.4, lean: 6 },
        { key: 'p1', iw: 486, ih: 760, x: 80, y: 13, w: 38.4, lean: 6 },
        { key: 'p2', iw: 891, ih: 691, x: 50, y: 37, w: 69.6, lean: 4 },
        { key: 'p3', iw: 955, ih: 213, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 385, ih: 432, x: 50, y: 93, w: 46, lean: 16, plaque: [0.1, 0.1, 0.1, 0.11] },
      ],
      floaters: [
        { key: 'p5', iw: 352, ih: 480, x: 14, top: 18, w: 18.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 289, ih: 283, x: 86, top: 22, w: 11.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.26, top: 70.09, width: 29.38, height: 18.98 },
    },
  },
  {
    id: 'pop-candy-land',
    look: 'popup',
    category: 'kids',
    label: { en: 'Candy Land', ka: 'კანფეტების ქვეყანა' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['candy', 'land', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f7f6f8',
    ink: '#392104',
    accents: ['#8c430d', '#4f0d8c'],
    popup: {
      bh: 134,
      table: ['#f7f6f8', '#ebe9ed'],
      floor: '#faf8f5',
      dot: 'rgba(117,28,200,.24)',
      edge: '#ebe9e6',
      cover: '#4f0d8c',
      coverInk: '#fff8ee',
      plaque: '#f8e3ca',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 645, ih: 701, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 518, ih: 749, x: 80, y: 13, w: 41.5, lean: 6 },
        { key: 'p2', iw: 962, ih: 636, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 875, ih: 323, x: 50, y: 64, w: 75.9, lean: 2 },
        { key: 'p4', iw: 560, ih: 444, x: 50, y: 93, w: 63.1, lean: 16, plaque: [0.2, 0.23, 0.19, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 461, ih: 685, x: 14, top: 18, w: 18, z: 12, anim: 'bob' },
        { key: 'p6', iw: 333, ih: 338, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.88, top: 73.94, width: 30.48, height: 12.41 },
    },
  },
  {
    id: 'pop-robot-lab',
    look: 'popup',
    category: 'kids',
    label: { en: 'Robot Lab', ka: 'რობოტების ლაბორატორია' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['robot', 'lab', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#e7f0f0',
    ink: '#0a3509',
    accents: ['#8c430d', '#8c460d'],
    popup: {
      bh: 134,
      table: ['#e7f0f0', '#c2dada'],
      floor: '#f6f6f3',
      dot: 'rgba(200,106,28,.24)',
      edge: '#e7e7e4',
      cover: '#8c460d',
      coverInk: '#fff8ee',
      plaque: '#fcfefc',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 480, ih: 753, x: 20, y: 10, w: 38.2, lean: 6 },
        { key: 'p1', iw: 629, ih: 523, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 686, ih: 659, x: 50, y: 37, w: 56.2, lean: 4 },
        { key: 'p3', iw: 704, ih: 301, x: 50, y: 64, w: 65.5, lean: 2 },
        { key: 'p4', iw: 529, ih: 386, x: 50, y: 93, w: 68.5, lean: 16, plaque: [0.2, 0.25, 0.2, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 392, ih: 529, x: 14, top: 18, w: 18.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 289, ih: 484, x: 86, top: 22, w: 8.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.93, top: 74.38, width: 32.53, height: 11.92 },
    },
  },
  {
    id: 'pop-knights-dragons',
    look: 'popup',
    category: 'kids',
    label: { en: 'Knights and Dragons', ka: 'რაინდები და დრაკონები' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['knights', 'dragons', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#f2f0e3',
    ink: '#3d3d00',
    accents: ['#8c560d', '#8c5f0d'],
    popup: {
      bh: 134,
      table: ['#f2f0e3', '#ded9b9'],
      floor: '#f9f6ef',
      dot: 'rgba(200,139,28,.24)',
      edge: '#eae7e1',
      cover: '#8c5f0d',
      coverInk: '#fff8ee',
      plaque: '#fffffd',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 349, ih: 752, x: 20, y: 10, w: 27.8, lean: 6 },
        { key: 'p1', iw: 640, ih: 497, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 992, ih: 706, x: 50, y: 37, w: 75.9, lean: 4 },
        { key: 'p3', iw: 1057, ih: 388, x: 50, y: 64, w: 76.3, lean: 2 },
        { key: 'p4', iw: 329, ih: 400, x: 50, y: 93, w: 47.7, lean: 16, plaque: [0.22, 0.21, 0.22, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 355, ih: 473, x: 14, top: 18, w: 19.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 262, ih: 195, x: 86, top: 22, w: 12.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 39.3, top: 70.46, width: 21.4, height: 15.78 },
    },
  },
  {
    id: 'pop-woodland-camp',
    look: 'popup',
    category: 'kids',
    label: { en: 'Woodland Camp', ka: 'ტყის ბანაკი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['woodland', 'camp', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#ebe9e4',
    ink: '#341d0a',
    accents: ['#66320a', '#8c4c0d'],
    popup: {
      bh: 134,
      table: ['#ebe9e4', '#cdc8bb'],
      floor: '#f7f4ef',
      dot: 'rgba(200,114,28,.24)',
      edge: '#e8e6e1',
      cover: '#8c4c0d',
      coverInk: '#fff8ee',
      plaque: '#e0aa7a',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 608, ih: 602, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 506, ih: 843, x: 80, y: 13, w: 36, lean: 6 },
        { key: 'p2', iw: 978, ih: 575, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 752, ih: 235, x: 50, y: 64, w: 89.6, lean: 2 },
        { key: 'p4', iw: 694, ih: 531, x: 50, y: 93, w: 65.3, lean: 16, plaque: [0.18, 0.21, 0.17, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 408, ih: 438, x: 14, top: 18, w: 21.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 281, ih: 349, x: 86, top: 22, w: 9.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.62, top: 73.37, width: 33.23, height: 13.44 },
    },
  },
  {
    id: 'pop-bunny-garden',
    look: 'popup',
    category: 'kids',
    label: { en: 'Bunny Garden', ka: 'კურდღლების ბაღი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['bunny', 'garden', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#f3f4f0',
    ink: '#372b06',
    accents: ['#8c450d', '#598c0d'],
    popup: {
      bh: 134,
      table: ['#f3f4f0', '#e2e3da'],
      floor: '#f9f7f3',
      dot: 'rgba(132,200,28,.24)',
      edge: '#eae8e4',
      cover: '#598c0d',
      coverInk: '#fff8ee',
      plaque: '#f8f0d7',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 372, ih: 699, x: 20, y: 10, w: 31.9, lean: 6 },
        { key: 'p1', iw: 588, ih: 869, x: 80, y: 13, w: 40.6, lean: 6 },
        { key: 'p2', iw: 937, ih: 697, x: 50, y: 37, w: 72.6, lean: 4 },
        { key: 'p3', iw: 1036, ih: 249, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 829, ih: 567, x: 50, y: 93, w: 73.1, lean: 16, plaque: [0.15, 0.21, 0.16, 0.41] },
      ],
      floaters: [
        { key: 'p5', iw: 484, ih: 764, x: 14, top: 18, w: 17.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 277, ih: 404, x: 86, top: 22, w: 9.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.88, top: 73.35, width: 39.96, height: 8.98 },
    },
  },
  {
    id: 'pop-football-star',
    look: 'popup',
    category: 'kids',
    label: { en: 'Football Star', ka: 'ფეხბურთის ვარსკვლავი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['football', 'star', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#ebf2eb',
    ink: '#192125',
    accents: ['#8c310d', '#708c0d'],
    popup: {
      bh: 134,
      table: ['#ebf2eb', '#ccdfcc'],
      floor: '#f7f7f1',
      dot: 'rgba(163,200,28,.24)',
      edge: '#e8e8e3',
      cover: '#708c0d',
      coverInk: '#fff8ee',
      plaque: '#f2f4f5',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 527, ih: 570, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 687, ih: 558, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 874, ih: 662, x: 50, y: 37, w: 71.3, lean: 4 },
        { key: 'p3', iw: 996, ih: 228, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 469, ih: 495, x: 50, y: 93, w: 47.4, lean: 16, plaque: [0.18, 0.15, 0.17, 0.48] },
      ],
      floaters: [
        { key: 'p5', iw: 463, ih: 568, x: 14, top: 18, w: 19.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 223, ih: 226, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.85, top: 71.85, width: 24.37, height: 8.87 },
    },
  },
  {
    id: 'pop-rock-band',
    look: 'popup',
    category: 'kids',
    label: { en: 'Little Rock Band', ka: 'პატარა როკ ჯგუფი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['rock', 'band', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#dfdef0',
    ink: '#2d2010',
    accents: ['#8c3b0d', '#1b0d8c'],
    popup: {
      bh: 134,
      table: ['#dfdef0', '#afadda'],
      floor: '#f3f1f3',
      dot: 'rgba(47,28,200,.24)',
      edge: '#e5e3e4',
      cover: '#1b0d8c',
      coverInk: '#fff8ee',
      plaque: '#ece0d0',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 496, ih: 588, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 453, ih: 602, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 906, ih: 569, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 815, ih: 318, x: 50, y: 64, w: 71.8, lean: 2 },
        { key: 'p4', iw: 588, ih: 328, x: 50, y: 93, w: 76, lean: 16, plaque: [0.19, 0.28, 0.19, 0.28] },
      ],
      floaters: [
        { key: 'p5', iw: 345, ih: 480, x: 14, top: 18, w: 18.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 157, ih: 337, x: 86, top: 22, w: 7.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 31.55, top: 77.57, width: 36.9, height: 8.78 },
    },
  },
  {
    id: 'pop-little-ballerina',
    look: 'popup',
    category: 'kids',
    label: { en: 'Little Ballerina', ka: 'პატარა ბალერინა' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['little', 'ballerina', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f5ebef',
    ink: '#11182c',
    accents: ['#8c510d', '#8c0d25'],
    popup: {
      bh: 134,
      table: ['#f5ebef', '#e5cdd6'],
      floor: '#f9f5f2',
      dot: 'rgba(200,28,60,.24)',
      edge: '#eae6e4',
      cover: '#8c0d25',
      coverInk: '#fff8ee',
      plaque: '#f1f3f9',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 387, ih: 576, x: 20, y: 10, w: 40.3, lean: 6 },
        { key: 'p1', iw: 572, ih: 485, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 689, ih: 581, x: 50, y: 37, w: 64, lean: 4 },
        { key: 'p3', iw: 807, ih: 325, x: 50, y: 64, w: 69.5, lean: 2 },
        { key: 'p4', iw: 366, ih: 495, x: 50, y: 93, w: 46, lean: 16, plaque: [0.26, 0.28, 0.26, 0.22] },
      ],
      floaters: [
        { key: 'p5', iw: 330, ih: 550, x: 14, top: 18, w: 17, z: 12, anim: 'bob' },
        { key: 'p6', iw: 213, ih: 327, x: 86, top: 22, w: 8.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 41.25, top: 70.81, width: 17.39, height: 14.55 },
    },
  },
  {
    id: 'pop-choo-choo-train',
    look: 'popup',
    category: 'kids',
    label: { en: 'Choo-Choo Train', ka: 'მატარებელი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['choo', 'choo', 'train', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#eaf0e7',
    ink: '#33200a',
    accents: ['#664a0a', '#638c0d'],
    popup: {
      bh: 134,
      table: ['#eaf0e7', '#cadac3'],
      floor: '#f6f6f0',
      dot: 'rgba(145,200,28,.24)',
      edge: '#e8e8e2',
      cover: '#638c0d',
      coverInk: '#fff8ee',
      plaque: '#e3b888',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 560, ih: 685, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 354, ih: 646, x: 80, y: 13, w: 32.9, lean: 6 },
        { key: 'p2', iw: 926, ih: 516, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 780, ih: 234, x: 50, y: 64, w: 93.3, lean: 2 },
        { key: 'p4', iw: 570, ih: 453, x: 50, y: 93, w: 62.9, lean: 16, plaque: [0.2, 0.19, 0.2, 0.48] },
      ],
      floaters: [
        { key: 'p5', iw: 314, ih: 396, x: 14, top: 18, w: 19.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 284, ih: 179, x: 86, top: 22, w: 13.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.05, top: 72.97, width: 29.69, height: 7.78 },
    },
  },
  {
    id: 'pop-bug-party',
    look: 'popup',
    category: 'kids',
    label: { en: 'Bug Party', ka: 'ხოჭოების წვეულება' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['bug', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#ebf3ed',
    ink: '#292414',
    accents: ['#8c530d', '#0d6a8c'],
    popup: {
      bh: 134,
      table: ['#ebf3ed', '#cde1d1'],
      floor: '#f7f7f2',
      dot: 'rgba(28,155,200,.24)',
      edge: '#e8e8e3',
      cover: '#0d6a8c',
      coverInk: '#fff8ee',
      plaque: '#f4f1ea',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 353, ih: 615, x: 20, y: 10, w: 34.4, lean: 6 },
        { key: 'p1', iw: 616, ih: 583, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 911, ih: 594, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 1034, ih: 399, x: 50, y: 64, w: 72.6, lean: 2 },
        { key: 'p4', iw: 383, ih: 420, x: 50, y: 93, w: 47.3, lean: 16, plaque: [0.2, 0.14, 0.16, 0.44] },
      ],
      floaters: [
        { key: 'p5', iw: 373, ih: 550, x: 14, top: 18, w: 18.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 271, ih: 268, x: 86, top: 22, w: 11.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.95, top: 70.8, width: 23.76, height: 10.43 },
    },
  },
  {
    id: 'pop-up-in-the-sky',
    look: 'popup',
    category: 'kids',
    label: { en: 'Up in the Sky', ka: 'ცაში' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['the', 'sky', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#eaf5f2',
    ink: '#062737',
    accents: ['#793f0c', '#0d658c'],
    popup: {
      bh: 134,
      table: ['#eaf5f2', '#cae7de'],
      floor: '#f6f8f3',
      dot: 'rgba(28,148,200,.24)',
      edge: '#e8e9e4',
      cover: '#0d658c',
      coverInk: '#fff8ee',
      plaque: '#9cd4ee',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 382, ih: 528, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 668, ih: 397, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 559, ih: 502, x: 50, y: 37, w: 60.1, lean: 4 },
        { key: 'p3', iw: 632, ih: 253, x: 50, y: 64, w: 69.9, lean: 2 },
        { key: 'p4', iw: 535, ih: 372, x: 50, y: 93, w: 71.9, lean: 16, plaque: [0.16, 0.2, 0.16, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 338, ih: 484, x: 14, top: 18, w: 18.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 333, ih: 243, x: 86, top: 22, w: 12.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.65, top: 73.14, width: 38.81, height: 13.99 },
    },
  },
  {
    id: 'pop-monster-bash',
    look: 'popup',
    category: 'kids',
    label: { en: 'Monster Bash', ka: 'მონსტრების წვეულება' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['monster', 'bash', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#e1e6e5',
    ink: '#33210a',
    accents: ['#8c4d0d', '#340d8c'],
    popup: {
      bh: 134,
      table: ['#e1e6e5', '#b3c0bd'],
      floor: '#f4f3ef',
      dot: 'rgba(81,28,200,.24)',
      edge: '#e5e5e1',
      cover: '#340d8c',
      coverInk: '#fff8ee',
      plaque: '#f5e8d7',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 460, ih: 836, x: 20, y: 10, w: 33, lean: 6 },
        { key: 'p1', iw: 556, ih: 902, x: 80, y: 13, w: 37, lean: 6 },
        { key: 'p2', iw: 934, ih: 713, x: 50, y: 37, w: 70.7, lean: 4 },
        { key: 'p3', iw: 860, ih: 229, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 521, ih: 479, x: 50, y: 93, w: 57.4, lean: 16, plaque: [0.23, 0.14, 0.25, 0.52] },
      ],
      floaters: [
        { key: 'p5', iw: 410, ih: 600, x: 14, top: 18, w: 18.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 260, ih: 239, x: 86, top: 22, w: 11.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.71, top: 70.4, width: 23.8, height: 8.68 },
    },
  },
  {
    id: 'pop-magic-circus',
    look: 'popup',
    category: 'kids',
    label: { en: 'Magic Circus', ka: 'ჯადოსნური ცირკი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['magic', 'circus', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#e9e3ec',
    ink: '#32200c',
    accents: ['#0d4b8c', '#8c0d1e'],
    popup: {
      bh: 134,
      table: ['#e9e3ec', '#c8bacf'],
      floor: '#f6f3f1',
      dot: 'rgba(200,28,50,.24)',
      edge: '#e7e4e3',
      cover: '#8c0d1e',
      coverInk: '#fff8ee',
      plaque: '#e9d0b2',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 595, ih: 678, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 512, ih: 721, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 647, ih: 649, x: 50, y: 37, w: 53.8, lean: 4 },
        { key: 'p3', iw: 739, ih: 279, x: 50, y: 64, w: 74.2, lean: 2 },
        { key: 'p4', iw: 543, ih: 301, x: 50, y: 93, w: 76, lean: 16, plaque: [0.17, 0.21, 0.17, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 401, ih: 557, x: 14, top: 18, w: 18.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 221, ih: 335, x: 86, top: 22, w: 8.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.26, top: 76.29, width: 39.49, height: 11.3 },
    },
  },
  {
    id: 'pop-game-on',
    look: 'popup',
    category: 'kids',
    label: { en: 'Game On', ka: 'თამაშის დღე' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['game', 'pop-up', '3d', 'გასაშლელი'],
    font: 'press-start',
    paper: '#e6f3f4',
    ink: '#1f1f1f',
    accents: ['#8c350d', '#0d608c'],
    popup: {
      bh: 134,
      table: ['#e6f3f4', '#c1e1e2'],
      floor: '#f5f7f3',
      dot: 'rgba(28,141,200,.24)',
      edge: '#e7e8e5',
      cover: '#0d608c',
      coverInk: '#fff8ee',
      plaque: '#fefefe',
      titleSize: 0.07,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 444, ih: 664, x: 20, y: 10, w: 40.1, lean: 6 },
        { key: 'p1', iw: 625, ih: 645, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 788, ih: 599, x: 50, y: 37, w: 71, lean: 4 },
        { key: 'p3', iw: 809, ih: 286, x: 50, y: 64, w: 79.2, lean: 2 },
        { key: 'p4', iw: 474, ih: 369, x: 50, y: 93, w: 64.2, lean: 16, plaque: [0.22, 0.26, 0.22, 0.26] },
      ],
      floaters: [
        { key: 'p5', iw: 400, ih: 482, x: 14, top: 18, w: 20, z: 12, anim: 'bob' },
        { key: 'p6', iw: 208, ih: 211, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.85, top: 74.45, width: 28.31, height: 11.3 },
    },
  },
  {
    id: 'pop-science-lab',
    look: 'popup',
    category: 'kids',
    label: { en: 'Little Scientist', ka: 'პატარა მეცნიერი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['science', 'lab', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#eceeee',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c3c0d'],
    popup: {
      bh: 134,
      table: ['#eceeee', '#d0d3d5'],
      floor: '#f7f6f2',
      dot: 'rgba(200,91,28,.24)',
      edge: '#e8e7e3',
      cover: '#8c3c0d',
      coverInk: '#fff8ee',
      plaque: '#454253',
      lightText: true,
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 506, ih: 631, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 612, ih: 609, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 689, ih: 592, x: 50, y: 37, w: 62.8, lean: 4 },
        { key: 'p3', iw: 629, ih: 406, x: 50, y: 64, w: 43.4, lean: 2 },
        { key: 'p4', iw: 568, ih: 409, x: 50, y: 93, w: 69.4, lean: 16, plaque: [0.15, 0.19, 0.16, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 472, ih: 520, x: 14, top: 18, w: 21, z: 12, anim: 'bob' },
        { key: 'p6', iw: 267, ih: 388, x: 86, top: 22, w: 9.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 31.1, top: 72.93, width: 37.69, height: 14.4 },
    },
  },
  {
    id: 'pop-teddy-picnic',
    look: 'popup',
    category: 'kids',
    label: { en: 'Teddy Picnic', ka: 'დათუნიების პიკნიკი' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['teddy', 'picnic', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f5f6f4',
    ink: '#2e1f0f',
    accents: ['#8c3a0d', '#0d628c'],
    popup: {
      bh: 134,
      table: ['#f5f6f4', '#e5e8e3'],
      floor: '#f9f8f4',
      dot: 'rgba(28,144,200,.24)',
      edge: '#eae9e5',
      cover: '#0d628c',
      coverInk: '#fff8ee',
      plaque: '#f0e6da',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 583, ih: 764, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 501, ih: 794, x: 80, y: 13, w: 37.9, lean: 6 },
        { key: 'p2', iw: 978, ih: 642, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 808, ih: 213, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 480, ih: 469, x: 50, y: 93, w: 56.4, lean: 16, plaque: [0.23, 0.47, 0.23, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 424, ih: 507, x: 14, top: 18, w: 20.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 260, ih: 357, x: 86, top: 22, w: 9.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.31, top: 78.33, width: 23.46, height: 8.38 },
    },
  },
  {
    id: 'pop-llama-fiesta',
    look: 'popup',
    category: 'kids',
    label: { en: 'Llama Fiesta', ka: 'ლამების ფიესტა' },
    blurb: { en: 'Characters pop up one by one when the card opens.', ka: 'ბარათის გახსნისას გმირები სათითაოდ ამოდიან.' },
    tags: ['llama', 'fiesta', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f2f2eb',
    ink: '#392704',
    accents: ['#8c500d', '#0d668c'],
    popup: {
      bh: 134,
      table: ['#f2f2eb', '#dedecd'],
      floor: '#f9f7f1',
      dot: 'rgba(28,149,200,.24)',
      edge: '#eae8e3',
      cover: '#0d668c',
      coverInk: '#fff8ee',
      plaque: '#faedd6',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 585, ih: 807, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 642, ih: 819, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 976, ih: 779, x: 50, y: 37, w: 67.7, lean: 4 },
        { key: 'p3', iw: 873, ih: 311, x: 50, y: 64, w: 78.6, lean: 2 },
        { key: 'p4', iw: 759, ih: 573, x: 50, y: 93, w: 66.2, lean: 16, plaque: [0.2, 0.21, 0.2, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 418, ih: 584, x: 14, top: 18, w: 18.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 295, ih: 299, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.13, top: 73.45, width: 31.7, height: 13.01 },
    },
  },
  {
    id: 'pop-disco-night',
    look: 'popup',
    category: 'party',
    label: { en: 'Disco Night', ka: 'დისკო ღამე' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['disco', 'night', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#f1dce1',
    ink: '#1f1f1e',
    accents: ['#8c3e0d', '#8c350d'],
    popup: {
      bh: 134,
      table: ['#f1dce1', '#dba7b3'],
      floor: '#f8f1ee',
      dot: 'rgba(200,82,28,.24)',
      edge: '#e9e2e0',
      cover: '#8c350d',
      coverInk: '#fff8ee',
      plaque: '#d8d8d7',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 379, ih: 591, x: 20, y: 10, w: 38.5, lean: 6 },
        { key: 'p1', iw: 651, ih: 586, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 689, ih: 609, x: 50, y: 37, w: 61.1, lean: 4 },
        { key: 'p3', iw: 967, ih: 154, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 772, ih: 393, x: 50, y: 93, w: 76, lean: 16, plaque: [0.17, 0.26, 0.17, 0.25] },
      ],
      floaters: [
        { key: 'p5', iw: 467, ih: 679, x: 14, top: 18, w: 18.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 366, ih: 428, x: 86, top: 22, w: 10.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.45, top: 78.42, width: 39.1, height: 8.9 },
    },
  },
  {
    id: 'pop-pizza-party',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Pizza Party', ka: 'პიცის წვეულება' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['pizza', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#f0eae7',
    ink: '#341f09',
    accents: ['#8c1e0d', '#8c2e0d'],
    popup: {
      bh: 134,
      table: ['#f0eae7', '#d8cac4'],
      floor: '#f8f5f0',
      dot: 'rgba(200,72,28,.24)',
      edge: '#e9e6e2',
      cover: '#8c2e0d',
      coverInk: '#fff8ee',
      plaque: '#eed2b5',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 465, ih: 636, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 410, ih: 631, x: 80, y: 13, w: 39, lean: 6 },
        { key: 'p2', iw: 875, ih: 637, x: 50, y: 37, w: 74.2, lean: 4 },
        { key: 'p3', iw: 1032, ih: 302, x: 50, y: 64, w: 95.7, lean: 2 },
        { key: 'p4', iw: 398, ih: 494, x: 50, y: 93, w: 46.7, lean: 16, plaque: [0.2, 0.36, 0.21, 0.17] },
      ],
      floaters: [
        { key: 'p5', iw: 337, ih: 514, x: 14, top: 18, w: 17.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 281, ih: 233, x: 86, top: 22, w: 12.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.89, top: 74.44, width: 21.84, height: 12.62 },
    },
  },
  {
    id: 'pop-karaoke-star',
    look: 'popup',
    category: 'party',
    label: { en: 'Karaoke Star', ka: 'კარაოკე' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['karaoke', 'star', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bangers',
    paper: '#e6e4ec',
    ink: '#1f1f1f',
    accents: ['#0d738c', '#8c630d'],
    popup: {
      bh: 134,
      table: ['#e6e4ec', '#c2bbcf'],
      floor: '#f5f3f1',
      dot: 'rgba(200,145,28,.24)',
      edge: '#e7e4e3',
      cover: '#8c630d',
      coverInk: '#fff8ee',
      plaque: '#fafafa',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 457, ih: 599, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 439, ih: 575, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 999, ih: 601, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 1009, ih: 140, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 823, ih: 366, x: 50, y: 93, w: 76, lean: 16, plaque: [0.16, 0.25, 0.16, 0.29] },
      ],
      floaters: [
        { key: 'p5', iw: 532, ih: 650, x: 14, top: 18, w: 19.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 171, ih: 322, x: 86, top: 22, w: 8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.97, top: 80.09, width: 39.94, height: 7.11 },
    },
  },
  {
    id: 'pop-sushi-night',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Sushi Night', ka: 'სუშის საღამო' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['sushi', 'night', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#e7ddd9',
    ink: '#32200b',
    accents: ['#662c0a', '#8c3d0d'],
    popup: {
      bh: 134,
      table: ['#e7ddd9', '#c3aa9f'],
      floor: '#f6f1ec',
      dot: 'rgba(200,93,28,.24)',
      edge: '#e7e3de',
      cover: '#8c3d0d',
      coverInk: '#fff8ee',
      plaque: '#d9a76f',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 343, ih: 633, x: 20, y: 10, w: 32.5, lean: 6 },
        { key: 'p1', iw: 614, ih: 693, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 984, ih: 532, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 732, ih: 443, x: 50, y: 64, w: 46.3, lean: 2 },
        { key: 'p4', iw: 505, ih: 525, x: 50, y: 93, w: 48.7, lean: 16, plaque: [0.2, 0.22, 0.18, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 404, ih: 505, x: 14, top: 18, w: 19.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 254, ih: 240, x: 86, top: 22, w: 11.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.63, top: 73.31, width: 23.67, height: 13.51 },
    },
  },
  {
    id: 'pop-flamingo-pool',
    look: 'popup',
    category: 'party',
    label: { en: 'Flamingo Pool Party', ka: 'ფლამინგოს წვეულება' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['flamingo', 'pool', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#eef4f1',
    ink: '#382205',
    accents: ['#79600c', '#0d698c'],
    popup: {
      bh: 134,
      table: ['#eef4f1', '#d4e5db'],
      floor: '#f8f7f3',
      dot: 'rgba(28,153,200,.24)',
      edge: '#e9e9e4',
      cover: '#0d698c',
      coverInk: '#fff8ee',
      plaque: '#f9eedc',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 541, ih: 707, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 610, ih: 723, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 854, ih: 442, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 957, ih: 203, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 872, ih: 428, x: 50, y: 93, w: 76, lean: 16, plaque: [0.14, 0.2, 0.14, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 464, ih: 610, x: 14, top: 18, w: 19.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 207, ih: 371, x: 86, top: 22, w: 8.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 28.47, top: 77.84, width: 42.95, height: 10.5 },
    },
  },
  {
    id: 'pop-lazy-sloth',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Lazy Sloth', ka: 'ზარმაცი ზარმაცა' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['lazy', 'sloth', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#e1e4df',
    ink: '#2f1f0e',
    accents: ['#8c440d', '#8c490d'],
    popup: {
      bh: 134,
      table: ['#e1e4df', '#b3bbb0'],
      floor: '#f4f3ee',
      dot: 'rgba(200,110,28,.24)',
      edge: '#e5e4e0',
      cover: '#8c490d',
      coverInk: '#fff8ee',
      plaque: '#ecdac7',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 699, ih: 648, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 473, ih: 669, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 823, ih: 626, x: 50, y: 37, w: 71, lean: 4 },
        { key: 'p3', iw: 842, ih: 293, x: 50, y: 64, w: 80.5, lean: 2 },
        { key: 'p4', iw: 743, ih: 497, x: 50, y: 93, w: 74.7, lean: 16, plaque: [0.19, 0.24, 0.2, 0.25] },
      ],
      floaters: [
        { key: 'p5', iw: 358, ih: 531, x: 14, top: 18, w: 18.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 173, ih: 208, x: 86, top: 22, w: 10, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 31.87, top: 74.13, width: 36.02, height: 11.79 },
    },
  },
  {
    id: 'pop-avocado-party',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Avo Party', ka: 'ავოკადოს წვეულება' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['avocado', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#eff5ee',
    ink: '#362307',
    accents: ['#8c470d', '#8c4a0d'],
    popup: {
      bh: 134,
      table: ['#eff5ee', '#d8e7d5'],
      floor: '#f8f8f2',
      dot: 'rgba(200,111,28,.24)',
      edge: '#e9e9e3',
      cover: '#8c4a0d',
      coverInk: '#fff8ee',
      plaque: '#f3ddbd',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 338, ih: 552, x: 20, y: 10, w: 36.7, lean: 6 },
        { key: 'p1', iw: 611, ih: 489, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1098, ih: 541, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 1032, ih: 357, x: 50, y: 64, w: 80.9, lean: 2 },
        { key: 'p4', iw: 387, ih: 426, x: 50, y: 93, w: 48.3, lean: 16, plaque: [0.19, 0.18, 0.19, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 386, ih: 510, x: 14, top: 18, w: 19.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 271, ih: 349, x: 86, top: 22, w: 9.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.04, top: 71.51, width: 23.74, height: 15.23 },
    },
  },
  {
    id: 'pop-gamer-zone',
    look: 'popup',
    category: 'party',
    label: { en: 'Gamer Zone', ka: 'გეიმერის ზონა' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['gamer', 'zone', 'pop-up', '3d', 'გასაშლელი'],
    font: 'orbitron',
    paper: '#dfddea',
    ink: '#26171c',
    accents: ['#8c390d', '#0d2c8c'],
    popup: {
      bh: 134,
      table: ['#dfddea', '#aeabc9'],
      floor: '#f3f1f1',
      dot: 'rgba(28,70,200,.24)',
      edge: '#e5e3e2',
      cover: '#0d2c8c',
      coverInk: '#fff8ee',
      plaque: '#faf7f8',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 426, ih: 604, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 460, ih: 737, x: 80, y: 13, w: 37.4, lean: 6 },
        { key: 'p2', iw: 928, ih: 626, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 793, ih: 278, x: 50, y: 64, w: 79.9, lean: 2 },
        { key: 'p4', iw: 481, ih: 436, x: 50, y: 93, w: 55.2, lean: 16, plaque: [0.17, 0.17, 0.17, 0.34] },
      ],
      floaters: [
        { key: 'p5', iw: 372, ih: 600, x: 14, top: 18, w: 17.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 379, ih: 257, x: 86, top: 22, w: 13.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.74, top: 72.47, width: 28.43, height: 11.51 },
    },
  },
  {
    id: 'pop-movie-night',
    look: 'popup',
    category: 'party',
    label: { en: 'Movie Night', ka: 'კინოს საღამო' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['movie', 'night', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bebas',
    paper: '#e1d9dd',
    ink: '#003d29',
    accents: ['#8c710d', '#8c0d25'],
    popup: {
      bh: 134,
      table: ['#e1d9dd', '#b4a0aa'],
      floor: '#f4f0ed',
      dot: 'rgba(200,28,60,.24)',
      edge: '#e5e2df',
      cover: '#8c0d25',
      coverInk: '#fff8ee',
      plaque: '#fcfffe',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 384, ih: 619, x: 20, y: 10, w: 37.2, lean: 6 },
        { key: 'p1', iw: 427, ih: 581, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 950, ih: 554, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 685, ih: 360, x: 50, y: 64, w: 53.3, lean: 2 },
        { key: 'p4', iw: 662, ih: 488, x: 50, y: 93, w: 67.8, lean: 16, plaque: [0.24, 0.33, 0.24, 0.25] },
      ],
      floaters: [
        { key: 'p5', iw: 408, ih: 567, x: 14, top: 18, w: 18.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 297, ih: 252, x: 86, top: 22, w: 11.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.95, top: 76.3, width: 28.1, height: 9.57 },
    },
  },
  {
    id: 'pop-bonjour-paris',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Bonjour Paris', ka: 'ბონჟური პარიზი' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['bonjour', 'paris', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#efe9e6',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c3c0d'],
    popup: {
      bh: 134,
      table: ['#efe9e6', '#d8c7c1'],
      floor: '#f8f4f0',
      dot: 'rgba(200,92,28,.24)',
      edge: '#e9e6e1',
      cover: '#8c3c0d',
      coverInk: '#fff8ee',
      plaque: '#605c69',
      lightText: true,
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 413, ih: 691, x: 20, y: 10, w: 35.9, lean: 6 },
        { key: 'p1', iw: 668, ih: 462, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 753, ih: 618, x: 50, y: 37, w: 65.8, lean: 4 },
        { key: 'p3', iw: 753, ih: 283, x: 50, y: 64, w: 74.5, lean: 2 },
        { key: 'p4', iw: 428, ih: 539, x: 50, y: 93, w: 46, lean: 16, plaque: [0.29, 0.17, 0.2, 0.32] },
      ],
      floaters: [
        { key: 'p5', iw: 404, ih: 538, x: 14, top: 18, w: 19.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 285, ih: 237, x: 86, top: 22, w: 12.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 42.21, top: 69.11, width: 18.65, height: 13.97 },
    },
  },
  {
    id: 'pop-not-impressed-cat',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Not Impressed Cat', ka: 'უკმაყოფილო კატა' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['not', 'impressed', 'cat', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#ebdfdd',
    ink: '#32200b',
    accents: ['#8c450d', '#8c320d'],
    popup: {
      bh: 134,
      table: ['#ebdfdd', '#ceb0ab'],
      floor: '#f7f2ed',
      dot: 'rgba(200,78,28,.24)',
      edge: '#e8e3df',
      cover: '#8c320d',
      coverInk: '#fff8ee',
      plaque: '#f5e9db',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 693, ih: 553, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 440, ih: 594, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 827, ih: 625, x: 50, y: 37, w: 71.5, lean: 4 },
        { key: 'p3', iw: 974, ih: 205, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 458, ih: 620, x: 50, y: 93, w: 46, lean: 16, plaque: [0.24, 0.22, 0.24, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 383, ih: 704, x: 14, top: 18, w: 16.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 327, ih: 246, x: 86, top: 22, w: 12.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 40.64, top: 68.96, width: 18.87, height: 16.63 },
    },
  },
  {
    id: 'pop-game-night',
    look: 'popup',
    category: 'party',
    label: { en: 'Game Night', ka: 'სათამაშო საღამო' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['game', 'night', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#f7ece6',
    ink: '#343409',
    accents: ['#8c4a0d', '#8c350d'],
    popup: {
      bh: 134,
      table: ['#f7ece6', '#ebcfc1'],
      floor: '#faf5f0',
      dot: 'rgba(200,83,28,.24)',
      edge: '#ebe6e1',
      cover: '#8c350d',
      coverInk: '#fff8ee',
      plaque: '#fefefc',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 598, ih: 633, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 390, ih: 666, x: 80, y: 13, w: 35.1, lean: 6 },
        { key: 'p2', iw: 818, ih: 583, x: 50, y: 37, w: 75.8, lean: 4 },
        { key: 'p3', iw: 800, ih: 283, x: 50, y: 64, w: 79.2, lean: 2 },
        { key: 'p4', iw: 382, ih: 529, x: 50, y: 93, w: 46, lean: 16, plaque: [0.19, 0.17, 0.19, 0.18] },
      ],
      floaters: [
        { key: 'p5', iw: 436, ih: 606, x: 14, top: 18, w: 18.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 315, ih: 290, x: 86, top: 22, w: 11.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.74, top: 67.02, width: 22.53, height: 19.53 },
    },
  },
  {
    id: 'pop-luau',
    look: 'popup',
    category: 'party',
    label: { en: 'Luau', ka: 'ჰავაის წვეულება' },
    blurb: { en: 'A party scene that springs up from the card.', ka: 'წვეულების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['luau', 'pop-up', '3d', 'გასაშლელი'],
    font: 'lobster',
    paper: '#f5e8e2',
    ink: '#392404',
    accents: ['#79460c', '#8c290d'],
    popup: {
      bh: 134,
      table: ['#f5e8e2', '#e6c7b8'],
      floor: '#f9f4ef',
      dot: 'rgba(200,66,28,.24)',
      edge: '#eae5e0',
      cover: '#8c290d',
      coverInk: '#fff8ee',
      plaque: '#f3d09c',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 448, ih: 758, x: 20, y: 10, w: 35.5, lean: 6 },
        { key: 'p1', iw: 454, ih: 742, x: 80, y: 13, w: 36.7, lean: 6 },
        { key: 'p2', iw: 943, ih: 685, x: 50, y: 37, w: 74.3, lean: 4 },
        { key: 'p3', iw: 869, ih: 341, x: 50, y: 64, w: 71.4, lean: 2 },
        { key: 'p4', iw: 684, ih: 585, x: 50, y: 93, w: 58.5, lean: 16, plaque: [0.23, 0.24, 0.23, 0.24] },
      ],
      floaters: [
        { key: 'p5', iw: 442, ih: 610, x: 14, top: 18, w: 18.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 289, ih: 326, x: 86, top: 22, w: 10.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.74, top: 73.98, width: 24.71, height: 12.11 },
    },
  },
  {
    id: 'pop-supra-birthday',
    look: 'popup',
    category: 'birthday',
    label: { en: 'Supra Birthday', ka: 'სუფრა' },
    blurb: { en: 'A paper birthday scene that unfolds in 3D.', ka: 'ქაღალდის საზეიმო სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['supra', 'birthday', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cormorant',
    paper: '#ebdfd7',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c3e0d'],
    popup: {
      bh: 134,
      table: ['#ebdfd7', '#ceb09c'],
      floor: '#f7f2ec',
      dot: 'rgba(200,94,28,.24)',
      edge: '#e8e3de',
      cover: '#8c3e0d',
      coverInk: '#fff8ee',
      plaque: '#c1865c',
      lightText: true,
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 581, ih: 739, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 544, ih: 741, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 971, ih: 713, x: 50, y: 37, w: 73.5, lean: 4 },
        { key: 'p3', iw: 1006, ih: 316, x: 50, y: 64, w: 89.1, lean: 2 },
        { key: 'p4', iw: 558, ih: 424, x: 50, y: 93, w: 65.8, lean: 16, plaque: [0.2, 0.18, 0.21, 0.3] },
      ],
      floaters: [
        { key: 'p5', iw: 371, ih: 475, x: 14, top: 18, w: 19.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 225, ih: 271, x: 86, top: 22, w: 10, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.61, top: 72.54, width: 30.57, height: 12.26 },
    },
  },
  {
    id: 'pop-eucalyptus-arch',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Eucalyptus Arch', ka: 'ევკალიპტის თაღი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['eucalyptus', 'arch', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#f3f3ec',
    ink: '#2c2c11',
    accents: ['#8c520d', '#8c5c0d'],
    popup: {
      bh: 134,
      table: ['#f3f3ec', '#e2e0ce'],
      floor: '#f9f7f1',
      dot: 'rgba(200,135,28,.24)',
      edge: '#eae8e3',
      cover: '#8c5c0d',
      coverInk: '#fff8ee',
      plaque: '#fdfdfb',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 516, ih: 722, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 454, ih: 738, x: 80, y: 13, w: 36.9, lean: 6 },
        { key: 'p2', iw: 1100, ih: 994, x: 50, y: 37, w: 59.8, lean: 4 },
        { key: 'p3', iw: 1080, ih: 276, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 535, ih: 682, x: 50, y: 93, w: 46, lean: 16, plaque: [0.26, 0.23, 0.27, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 454, ih: 520, x: 14, top: 18, w: 20.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 309, ih: 181, x: 86, top: 22, w: 14.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 41.21, top: 70.55, width: 17.29, height: 15.44 },
    },
  },
  {
    id: 'pop-lavender-fields',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Lavender Fields', ka: 'ლავანდის მინდვრები' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['lavender', 'fields', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#eceaeb',
    ink: '#2f2f0e',
    accents: ['#3d0d8c', '#8c7d0d'],
    popup: {
      bh: 134,
      table: ['#eceaeb', '#d1cccd'],
      floor: '#f7f5f1',
      dot: 'rgba(200,180,28,.24)',
      edge: '#e8e6e3',
      cover: '#8c7d0d',
      coverInk: '#fff8ee',
      plaque: '#fefefc',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 385, ih: 703, x: 20, y: 10, w: 32.9, lean: 6 },
        { key: 'p1', iw: 888, ih: 627, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 767, ih: 838, x: 50, y: 37, w: 50, lean: 4 },
        { key: 'p3', iw: 854, ih: 351, x: 50, y: 64, w: 68.1, lean: 2 },
        { key: 'p4', iw: 437, ih: 535, x: 50, y: 93, w: 47.4, lean: 16, plaque: [0.15, 0.16, 0.26, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 321, ih: 564, x: 14, top: 18, w: 16.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 351, ih: 338, x: 86, top: 22, w: 11.2, z: 18, anim: 'glide' },
        { key: 'p7', iw: 281, ih: 268, x: 70, top: 46, w: 11.3, z: 24, anim: 'bob' },
      ],
      thumbText: { left: 36.77, top: 68.88, width: 22.12, height: 18.63 },
    },
  },
  {
    id: 'pop-vineyard-wedding',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Vineyard Wedding', ka: 'ვენახში ქორწილი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['vineyard', 'wedding', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pinyon-montserrat',
    paper: '#e6e3e0',
    ink: '#2c1f11',
    accents: ['#66350a', '#8c480d'],
    popup: {
      bh: 134,
      table: ['#e6e3e0', '#c0b9b2'],
      floor: '#f5f3ee',
      dot: 'rgba(200,108,28,.24)',
      edge: '#e7e4e0',
      cover: '#8c480d',
      coverInk: '#fff8ee',
      plaque: '#cba987',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 576, ih: 609, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 541, ih: 697, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 620, ih: 707, x: 50, y: 37, w: 50, lean: 4 },
        { key: 'p3', iw: 665, ih: 268, x: 50, y: 64, w: 69.5, lean: 2 },
        { key: 'p4', iw: 390, ih: 392, x: 50, y: 93, w: 49.7, lean: 16, plaque: [0.14, 0.14, 0.14, 0.18] },
      ],
      floaters: [
        { key: 'p5', iw: 397, ih: 262, x: 14, top: 18, w: 26, z: 12, anim: 'bob' },
        { key: 'p6', iw: 135, ih: 294, x: 86, top: 22, w: 7.5, z: 18, anim: 'glide' },
        { key: 'p7', iw: 135, ih: 292, x: 70, top: 46, w: 7.5, z: 24, anim: 'bob' },
      ],
      thumbText: { left: 35.69, top: 71.72, width: 28.42, height: 15.91 },
    },
  },
  {
    id: 'pop-boho-pampas',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Boho Pampas', ka: 'ბოჰო' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['boho', 'pampas', 'pop-up', '3d', 'გასაშლელი'],
    font: 'caveat',
    paper: '#f8f0ea',
    ink: '#22221b',
    accents: ['#8c3c0d', '#8c300d'],
    popup: {
      bh: 134,
      table: ['#f8f0ea', '#eddaca'],
      floor: '#faf6f1',
      dot: 'rgba(200,76,28,.24)',
      edge: '#ebe7e2',
      cover: '#8c300d',
      coverInk: '#fff8ee',
      plaque: '#f7f7f5',
      titleSize: 0.15,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 393, ih: 695, x: 20, y: 10, w: 33.9, lean: 6 },
        { key: 'p1', iw: 520, ih: 657, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 836, ih: 739, x: 50, y: 37, w: 61.1, lean: 4 },
        { key: 'p3', iw: 695, ih: 337, x: 50, y: 64, w: 57.7, lean: 2 },
        { key: 'p4', iw: 490, ih: 618, x: 50, y: 93, w: 46, lean: 16, plaque: [0.25, 0.21, 0.25, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 373, ih: 641, x: 14, top: 18, w: 16.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 367, ih: 322, x: 86, top: 22, w: 11.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 40.99, top: 70.45, width: 18.16, height: 16.08 },
    },
  },
  {
    id: 'pop-crystal-chandelier',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Crystal Chandelier', ka: 'ბროლის ჭაღი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['crystal', 'chandelier', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#fdfbf8',
    ink: '#1e1a24',
    accents: ['#8c430d', '#8c5a0d'],
    popup: {
      bh: 134,
      table: ['#fdfbf8', '#f9f6ee'],
      floor: '#fcf9f5',
      dot: 'rgba(200,133,28,.24)',
      edge: '#eceae6',
      cover: '#8c5a0d',
      coverInk: '#fff8ee',
      plaque: '#f2f1f4',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 382, ih: 766, x: 20, y: 10, w: 29.9, lean: 6 },
        { key: 'p1', iw: 455, ih: 772, x: 80, y: 13, w: 35.4, lean: 6 },
        { key: 'p2', iw: 879, ih: 811, x: 50, y: 37, w: 58.5, lean: 4 },
        { key: 'p3', iw: 779, ih: 260, x: 50, y: 64, w: 83.9, lean: 2 },
        { key: 'p4', iw: 396, ih: 528, x: 50, y: 93, w: 46, lean: 16, plaque: [0.1, 0.1, 0.1, 0.11] },
      ],
      floaters: [
        { key: 'p5', iw: 341, ih: 493, x: 14, top: 18, w: 18.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 224, ih: 183, x: 86, top: 22, w: 12.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.15, top: 65.82, width: 29.59, height: 22.82 },
    },
  },
  {
    id: 'pop-burgundy-autumn',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Burgundy Autumn', ka: 'შემოდგომის ქორწილი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['burgundy', 'autumn', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pinyon-montserrat',
    paper: '#f9f1e2',
    ink: '#362607',
    accents: ['#8c330d', '#8c590d'],
    popup: {
      bh: 134,
      table: ['#f9f1e2', '#f0dbb7'],
      floor: '#fbf6ef',
      dot: 'rgba(200,132,28,.24)',
      edge: '#ece8e0',
      cover: '#8c590d',
      coverInk: '#fff8ee',
      plaque: '#f9f0df',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 551, ih: 655, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 399, ih: 744, x: 80, y: 13, w: 32.2, lean: 6 },
        { key: 'p2', iw: 920, ih: 712, x: 50, y: 37, w: 69.8, lean: 4 },
        { key: 'p3', iw: 1008, ih: 333, x: 50, y: 64, w: 84.8, lean: 2 },
        { key: 'p4', iw: 818, ih: 637, x: 50, y: 93, w: 64.2, lean: 16, plaque: [0.17, 0.19, 0.17, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 319, ih: 362, x: 14, top: 18, w: 20.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 261, ih: 177, x: 86, top: 22, w: 13.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.02, top: 72.95, width: 33.96, height: 14.32 },
    },
  },
  {
    id: 'pop-amalfi-lemons',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Amalfi Lemons', ka: 'ლიმონის ბაღი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['amalfi', 'lemons', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#edeeeb',
    ink: '#14132a',
    accents: ['#8c580d', '#0d8c84'],
    popup: {
      bh: 134,
      table: ['#edeeeb', '#d2d6cc'],
      floor: '#f7f6f1',
      dot: 'rgba(28,200,190,.24)',
      edge: '#e8e7e3',
      cover: '#0d8c84',
      coverInk: '#fff8ee',
      plaque: '#f0f0f7',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 409, ih: 715, x: 20, y: 10, w: 34.3, lean: 6 },
        { key: 'p1', iw: 429, ih: 667, x: 80, y: 13, w: 38.6, lean: 6 },
        { key: 'p2', iw: 543, ih: 695, x: 50, y: 37, w: 50, lean: 4 },
        { key: 'p3', iw: 747, ih: 237, x: 50, y: 64, w: 88.3, lean: 2 },
        { key: 'p4', iw: 392, ih: 545, x: 50, y: 93, w: 46, lean: 16, plaque: [0.25, 0.22, 0.25, 0.22] },
      ],
      floaters: [
        { key: 'p5', iw: 384, ih: 454, x: 14, top: 18, w: 20.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 183, ih: 151, x: 86, top: 22, w: 12.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 40.81, top: 68.23, width: 18.31, height: 17.13 },
    },
  },
  {
    id: 'pop-winter-wedding',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Winter Wedding', ka: 'ზამთრის ქორწილი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['winter', 'wedding', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#f3f5f7',
    ink: '#141e29',
    accents: ['#47790c', '#8c6c0d'],
    popup: {
      bh: 134,
      table: ['#f3f5f7', '#e2e5eb'],
      floor: '#f9f7f4',
      dot: 'rgba(200,157,28,.24)',
      edge: '#eae9e6',
      cover: '#8c6c0d',
      coverInk: '#fff8ee',
      plaque: '#e9eef3',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 416, ih: 717, x: 20, y: 10, w: 34.8, lean: 6 },
        { key: 'p1', iw: 626, ih: 459, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 906, ih: 763, x: 50, y: 37, w: 64.1, lean: 4 },
        { key: 'p3', iw: 866, ih: 208, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 578, ih: 524, x: 50, y: 93, w: 55.2, lean: 16, plaque: [0.09, 0.1, 0.1, 0.11] },
      ],
      floaters: [
        { key: 'p5', iw: 299, ih: 598, x: 14, top: 18, w: 15.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 198, ih: 163, x: 86, top: 22, w: 12.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 32.24, top: 70.79, width: 35.43, height: 18.44 },
    },
  },
  {
    id: 'pop-cherry-blossom',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Cherry Blossom', ka: 'ალუბლის ყვავილობა' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['cherry', 'blossom', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#f9f7f2',
    ink: '#30230d',
    accents: ['#8c0d1a', '#8c3d0d'],
    popup: {
      bh: 134,
      table: ['#f9f7f2', '#efebdf'],
      floor: '#faf8f3',
      dot: 'rgba(200,93,28,.24)',
      edge: '#ebe9e5',
      cover: '#8c3d0d',
      coverInk: '#fff8ee',
      plaque: '#f3eadb',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 656, ih: 731, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 289, ih: 731, x: 80, y: 13, w: 24, lean: 6 },
        { key: 'p2', iw: 831, ih: 721, x: 50, y: 37, w: 62.2, lean: 4 },
        { key: 'p3', iw: 667, ih: 235, x: 50, y: 64, w: 79.5, lean: 2 },
        { key: 'p4', iw: 524, ih: 527, x: 50, y: 93, w: 49.7, lean: 16, plaque: [0.16, 0.17, 0.15, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 319, ih: 532, x: 14, top: 18, w: 17, z: 12, anim: 'bob' },
        { key: 'p6', iw: 218, ih: 158, x: 86, top: 22, w: 12.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 36.49, top: 72.3, width: 27.18, height: 15.71 },
    },
  },
  {
    id: 'pop-art-deco-gold',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Art Deco', ka: 'არტ დეკო' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['art', 'deco', 'gold', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cinzel',
    paper: '#e1ddd7',
    ink: '#2e250f',
    accents: ['#8c5e0d', '#8c5a0d'],
    popup: {
      bh: 134,
      table: ['#e1ddd7', '#b3aa9c'],
      floor: '#f4f1ec',
      dot: 'rgba(200,133,28,.24)',
      edge: '#e5e3de',
      cover: '#8c5a0d',
      coverInk: '#fff8ee',
      plaque: '#f5f0e4',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 475, ih: 695, x: 20, y: 10, w: 41, lean: 6 },
        { key: 'p1', iw: 282, ih: 680, x: 80, y: 13, w: 24.9, lean: 6 },
        { key: 'p2', iw: 774, ih: 715, x: 50, y: 37, w: 58.5, lean: 4 },
        { key: 'p3', iw: 936, ih: 302, x: 50, y: 64, w: 86.8, lean: 2 },
        { key: 'p4', iw: 400, ih: 522, x: 50, y: 93, w: 46, lean: 16, plaque: [0.25, 0.22, 0.25, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 389, ih: 448, x: 14, top: 18, w: 20.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 234, ih: 183, x: 86, top: 22, w: 12.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 40.8, top: 69.83, width: 18.33, height: 15.64 },
    },
  },
  {
    id: 'pop-beach-wedding',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Beach Wedding', ka: 'ქორწილი ზღვაზე' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['beach', 'wedding', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f6f0eb',
    ink: '#2e2f0e',
    accents: ['#8c490d', '#8c330d'],
    popup: {
      bh: 134,
      table: ['#f6f0eb', '#ead9cd'],
      floor: '#faf6f1',
      dot: 'rgba(200,80,28,.24)',
      edge: '#ebe7e3',
      cover: '#8c330d',
      coverInk: '#fff8ee',
      plaque: '#fdfdfb',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 533, ih: 758, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 701, ih: 405, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 900, ih: 818, x: 50, y: 37, w: 59.4, lean: 4 },
        { key: 'p3', iw: 916, ih: 218, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 457, ih: 487, x: 50, y: 93, w: 54.4, lean: 16, plaque: [0.22, 0.22, 0.22, 0.56] },
      ],
      floaters: [
        { key: 'p5', iw: 386, ih: 365, x: 14, top: 18, w: 22.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 223, ih: 195, x: 86, top: 22, w: 11.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.88, top: 70.61, width: 24.15, height: 6.06 },
    },
  },
  {
    id: 'pop-rustic-barn',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Rustic Barn', ka: 'რუსტიკული ქორწილი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['rustic', 'barn', 'pop-up', '3d', 'გასაშლელი'],
    font: 'caveat',
    paper: '#f5eee6',
    ink: '#2c2011',
    accents: ['#79500c', '#8c470d'],
    popup: {
      bh: 134,
      table: ['#f5eee6', '#e6d4c1'],
      floor: '#f9f6f0',
      dot: 'rgba(200,106,28,.24)',
      edge: '#eae7e1',
      cover: '#8c470d',
      coverInk: '#fff8ee',
      plaque: '#ece0d2',
      titleSize: 0.15,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 581, ih: 617, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 521, ih: 605, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 922, ih: 614, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 771, ih: 407, x: 50, y: 64, w: 53, lean: 2 },
        { key: 'p4', iw: 487, ih: 447, x: 50, y: 93, w: 54.5, lean: 16, plaque: [0.21, 0.32, 0.21, 0.34] },
      ],
      floaters: [
        { key: 'p5', iw: 408, ih: 390, x: 14, top: 18, w: 22.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 213, ih: 184, x: 86, top: 22, w: 11.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.63, top: 75.96, width: 24.74, height: 7.89 },
    },
  },
  {
    id: 'pop-beach-couple',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Barefoot Beach', ka: 'ფეხშიშველი ზღვაზე' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['beach', 'couple', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f1eee4',
    ink: '#311e0c',
    accents: ['#8c300d', '#8c2c0d'],
    popup: {
      bh: 134,
      table: ['#f1eee4', '#ddd4bc'],
      floor: '#f8f6ef',
      dot: 'rgba(200,70,28,.24)',
      edge: '#eae7e1',
      cover: '#8c2c0d',
      coverInk: '#fff8ee',
      plaque: '#fcf9f5',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 677, ih: 724, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 488, ih: 719, x: 80, y: 13, w: 40.7, lean: 6 },
        { key: 'p2', iw: 779, ih: 733, x: 50, y: 37, w: 57.4, lean: 4 },
        { key: 'p3', iw: 874, ih: 240, x: 50, y: 64, w: 102, lean: 2 },
        { key: 'p4', iw: 427, ih: 437, x: 50, y: 93, w: 48.9, lean: 16, plaque: [0.1, 0.1, 0.1, 0.11] },
      ],
      floaters: [
        { key: 'p5', iw: 388, ih: 524, x: 14, top: 18, w: 18.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 218, ih: 206, x: 86, top: 22, w: 11.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.43, top: 70.81, width: 31.15, height: 18.33 },
    },
  },
  {
    id: 'pop-paris-couple',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Paris Romance', ka: 'რომანი პარიზში' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['paris', 'couple', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#f0e2e0',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c320d'],
    popup: {
      bh: 134,
      table: ['#f0e2e0', '#dab7b2'],
      floor: '#f8f2ee',
      dot: 'rgba(200,78,28,.24)',
      edge: '#e9e4e0',
      cover: '#8c320d',
      coverInk: '#fff8ee',
      plaque: '#454041',
      lightText: true,
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 421, ih: 767, x: 20, y: 10, w: 32.9, lean: 6 },
        { key: 'p1', iw: 216, ih: 770, x: 80, y: 13, w: 24, lean: 6 },
        { key: 'p2', iw: 736, ih: 715, x: 50, y: 37, w: 55.6, lean: 4 },
        { key: 'p3', iw: 836, ih: 295, x: 50, y: 64, w: 79.3, lean: 2 },
        { key: 'p4', iw: 357, ih: 460, x: 50, y: 93, w: 46, lean: 16, plaque: [0.22, 0.21, 0.31, 0.31] },
      ],
      floaters: [
        { key: 'p5', iw: 416, ih: 493, x: 14, top: 18, w: 20.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 199, ih: 274, x: 86, top: 22, w: 9.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 39.77, top: 69.83, width: 17.2, height: 13.32 },
    },
  },
  {
    id: 'pop-mountain-couple',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Mountain Vows', ka: 'მთაში' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['mountain', 'couple', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#e9eee5',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c5b0d'],
    popup: {
      bh: 134,
      table: ['#e9eee5', '#c9d5bd'],
      floor: '#f6f6ef',
      dot: 'rgba(200,134,28,.24)',
      edge: '#e8e7e1',
      cover: '#8c5b0d',
      coverInk: '#fff8ee',
      plaque: '#ca8b60',
      lightText: true,
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 514, ih: 768, x: 20, y: 10, w: 40.2, lean: 6 },
        { key: 'p1', iw: 615, ih: 775, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1074, ih: 747, x: 50, y: 37, w: 77.6, lean: 4 },
        { key: 'p3', iw: 814, ih: 418, x: 50, y: 64, w: 54.5, lean: 2 },
        { key: 'p4', iw: 503, ih: 501, x: 50, y: 93, w: 50.2, lean: 16, plaque: [0.13, 0.17, 0.15, 0.51] },
      ],
      floaters: [
        { key: 'p5', iw: 396, ih: 571, x: 14, top: 18, w: 18.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 383, ih: 443, x: 86, top: 22, w: 10.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.44, top: 72.44, width: 28.56, height: 7.54 },
    },
  },
  {
    id: 'pop-just-married-car',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Just Married Ride', ka: 'ახალდაქორწინებულები' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['just', 'married', 'car', 'pop-up', '3d', 'გასაშლელი'],
    font: 'lobster',
    paper: '#f1e9df',
    ink: '#301f0d',
    accents: ['#8c310d', '#8c510d'],
    popup: {
      bh: 134,
      table: ['#f1e9df', '#dbc9ae'],
      floor: '#f8f4ee',
      dot: 'rgba(200,120,28,.24)',
      edge: '#e9e6df',
      cover: '#8c510d',
      coverInk: '#fff8ee',
      plaque: '#f0e0cf',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 653, ih: 758, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 322, ih: 778, x: 80, y: 13, w: 24.8, lean: 6 },
        { key: 'p2', iw: 929, ih: 674, x: 50, y: 37, w: 74.4, lean: 4 },
        { key: 'p3', iw: 836, ih: 275, x: 50, y: 64, w: 85.1, lean: 2 },
        { key: 'p4', iw: 502, ih: 269, x: 50, y: 93, w: 76, lean: 16, plaque: [0.15, 0.2, 0.15, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 367, ih: 497, x: 14, top: 18, w: 18.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 193, ih: 271, x: 86, top: 22, w: 9.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.08, top: 76.71, width: 41.72, height: 11.1 },
    },
  },
  {
    id: 'pop-garden-dance',
    look: 'popup',
    category: 'wedding',
    label: { en: 'First Dance', ka: 'პირველი ცეკვა' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['garden', 'dance', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#e1dfdd',
    ink: '#282715',
    accents: ['#8c320d', '#8c740d'],
    popup: {
      bh: 134,
      table: ['#e1dfdd', '#b3afa9'],
      floor: '#f4f2ed',
      dot: 'rgba(200,167,28,.24)',
      edge: '#e5e3df',
      cover: '#8c740d',
      coverInk: '#fff8ee',
      plaque: '#fdfdfc',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 700, ih: 783, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 478, ih: 738, x: 80, y: 13, w: 38.9, lean: 6 },
        { key: 'p2', iw: 862, ih: 719, x: 50, y: 37, w: 64.7, lean: 4 },
        { key: 'p3', iw: 775, ih: 356, x: 50, y: 64, w: 61, lean: 2 },
        { key: 'p4', iw: 502, ih: 517, x: 50, y: 93, w: 51.9, lean: 16, plaque: [0.21, 0.22, 0.21, 0.23] },
      ],
      floaters: [
        { key: 'p5', iw: 415, ih: 488, x: 14, top: 18, w: 20.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 292, ih: 202, x: 86, top: 22, w: 13.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.98, top: 72.4, width: 23.7, height: 13.75 },
    },
  },
  {
    id: 'pop-cat-wedding',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Purrfect Match', ka: 'იდეალური წყვილი' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['cat', 'wedding', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f5eee9',
    ink: '#2f1b0e',
    accents: ['#8c3b0d', '#8c310d'],
    popup: {
      bh: 134,
      table: ['#f5eee9', '#e6d4c9'],
      floor: '#f9f6f1',
      dot: 'rgba(200,76,28,.24)',
      edge: '#eae7e2',
      cover: '#8c310d',
      coverInk: '#fff8ee',
      plaque: '#f2e3d9',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 638, ih: 755, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 476, ih: 721, x: 80, y: 13, w: 39.6, lean: 6 },
        { key: 'p2', iw: 954, ih: 680, x: 50, y: 37, w: 75.8, lean: 4 },
        { key: 'p3', iw: 899, ih: 266, x: 50, y: 64, w: 94.6, lean: 2 },
        { key: 'p4', iw: 483, ih: 443, x: 50, y: 93, w: 54.5, lean: 16, plaque: [0.16, 0.17, 0.16, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 414, ih: 493, x: 14, top: 18, w: 20.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 272, ih: 181, x: 86, top: 22, w: 13.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.23, top: 72.4, width: 29.24, height: 14.91 },
    },
  },
  {
    id: 'pop-penguin-wedding',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Penguin Love', ka: 'პინგვინების სიყვარული' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['penguin', 'wedding', 'pop-up', '3d', 'გასაშლელი'],
    font: 'pacifico',
    paper: '#f1eeee',
    ink: '#082535',
    accents: ['#0d5c8c', '#8c3f0d'],
    popup: {
      bh: 134,
      table: ['#f1eeee', '#ddd6d4'],
      floor: '#f8f6f2',
      dot: 'rgba(200,96,28,.24)',
      edge: '#eae7e3',
      cover: '#8c3f0d',
      coverInk: '#fff8ee',
      plaque: '#e6f3fa',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 612, ih: 611, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 340, ih: 463, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 971, ih: 538, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 843, ih: 251, x: 50, y: 64, w: 94, lean: 2 },
        { key: 'p4', iw: 476, ih: 463, x: 50, y: 93, w: 52.3, lean: 16, plaque: [0.21, 0.22, 0.21, 0.25] },
      ],
      floaters: [
        { key: 'p5', iw: 346, ih: 508, x: 14, top: 18, w: 18.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 335, ih: 294, x: 86, top: 22, w: 11.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.12, top: 73.31, width: 23.69, height: 12.6 },
    },
  },
  {
    id: 'pop-kartuli-dance',
    look: 'popup',
    category: 'wedding',
    label: { en: 'Kartuli Dance', ka: 'ქართული ცეკვა' },
    blurb: { en: 'A paper wedding scene that unfolds when opened.', ka: 'ქაღალდის საქორწილო სცენა, რომელიც გახსნისას იშლება.' },
    tags: ['kartuli', 'dance', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cormorant',
    paper: '#e0d9d7',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c3e0d'],
    popup: {
      bh: 134,
      table: ['#e0d9d7', '#b2a09b'],
      floor: '#f4f0ec',
      dot: 'rgba(200,95,28,.24)',
      edge: '#e5e2dd',
      cover: '#8c3e0d',
      coverInk: '#fff8ee',
      plaque: '#cc8a55',
      lightText: true,
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 535, ih: 787, x: 20, y: 10, w: 40.8, lean: 6 },
        { key: 'p1', iw: 719, ih: 595, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 734, ih: 670, x: 50, y: 37, w: 59.2, lean: 4 },
        { key: 'p3', iw: 866, ih: 346, x: 50, y: 64, w: 70.1, lean: 2 },
        { key: 'p4', iw: 547, ih: 389, x: 50, y: 93, w: 70.3, lean: 16, plaque: [0.15, 0.16, 0.23, 0.3] },
      ],
      floaters: [
        { key: 'p5', iw: 395, ih: 527, x: 14, top: 18, w: 19, z: 12, anim: 'bob' },
        { key: 'p6', iw: 296, ih: 298, x: 86, top: 22, w: 11, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.5, top: 72.2, width: 34.67, height: 12.64 },
    },
  },
  {
    id: 'pop-baby-clouds',
    look: 'popup',
    category: 'baby',
    label: { en: 'Baby Clouds', ka: 'ბავშვის ღრუბლები' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['baby', 'clouds', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f8f8fa',
    ink: '#091334',
    accents: ['#8c420d', '#2a0d8c'],
    popup: {
      bh: 134,
      table: ['#f8f8fa', '#eeeff3'],
      floor: '#faf9f5',
      dot: 'rgba(67,28,200,.24)',
      edge: '#ebeae6',
      cover: '#2a0d8c',
      coverInk: '#fff8ee',
      plaque: '#f9fafd',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 503, ih: 654, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 541, ih: 659, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1042, ih: 681, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 948, ih: 320, x: 50, y: 64, w: 83, lean: 2 },
        { key: 'p4', iw: 506, ih: 373, x: 50, y: 93, w: 67.8, lean: 16, plaque: [0.15, 0.17, 0.15, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 427, ih: 641, x: 14, top: 18, w: 18, z: 12, anim: 'bob' },
        { key: 'p6', iw: 213, ih: 385, x: 86, top: 22, w: 8.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 31.03, top: 72.43, width: 37.72, height: 14.97 },
    },
  },
  {
    id: 'pop-christening',
    look: 'popup',
    category: 'baby',
    label: { en: 'Christening', ka: 'ნათლობა' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['christening', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#f8f8f3',
    ink: '#1f1f1e',
    accents: ['#60660a', '#8c6a0d'],
    popup: {
      bh: 134,
      table: ['#f8f8f3', '#eeede1'],
      floor: '#faf8f3',
      dot: 'rgba(200,154,28,.24)',
      edge: '#ebe9e5',
      cover: '#8c6a0d',
      coverInk: '#fff8ee',
      plaque: '#f6f8f7',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 351, ih: 657, x: 20, y: 10, w: 32.1, lean: 6 },
        { key: 'p1', iw: 239, ih: 646, x: 80, y: 13, w: 24, lean: 6 },
        { key: 'p2', iw: 481, ih: 640, x: 50, y: 37, w: 50, lean: 4 },
        { key: 'p3', iw: 630, ih: 226, x: 50, y: 64, w: 78.1, lean: 2 },
        { key: 'p4', iw: 325, ih: 421, x: 50, y: 93, w: 46, lean: 16, plaque: [0.18, 0.21, 0.17, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 366, ih: 288, x: 14, top: 18, w: 24.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 300, ih: 256, x: 86, top: 22, w: 11.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.16, top: 69.62, width: 23.78, height: 17.58 },
    },
  },
  {
    id: 'pop-gender-reveal',
    look: 'popup',
    category: 'baby',
    label: { en: 'Boy or Girl', ka: 'ბიჭი თუ გოგო' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['gender', 'reveal', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#faf9f9',
    ink: '#231d1b',
    accents: ['#0d438c', '#588c0d'],
    popup: {
      bh: 134,
      table: ['#faf9f9', '#f2eff1'],
      floor: '#fbf9f5',
      dot: 'rgba(130,200,28,.24)',
      edge: '#eceae6',
      cover: '#588c0d',
      coverInk: '#fff8ee',
      plaque: '#f5f3f2',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 547, ih: 577, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 508, ih: 621, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 689, ih: 623, x: 50, y: 37, w: 59.7, lean: 4 },
        { key: 'p3', iw: 616, ih: 288, x: 50, y: 64, w: 59.9, lean: 2 },
        { key: 'p4', iw: 619, ih: 423, x: 50, y: 93, w: 73.2, lean: 16, plaque: [0.15, 0.17, 0.14, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 383, ih: 579, x: 14, top: 18, w: 17.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 252, ih: 285, x: 86, top: 22, w: 10.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.7, top: 72.48, width: 40.83, height: 14.94 },
    },
  },
  {
    id: 'pop-woodland-baby',
    look: 'popup',
    category: 'baby',
    label: { en: 'Woodland Baby', ka: 'ტყის პატარა' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['woodland', 'baby', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f1f4f5',
    ink: '#351e08',
    accents: ['#8c460d', '#0d628c'],
    popup: {
      bh: 134,
      table: ['#f1f4f5', '#dce4e5'],
      floor: '#f8f7f4',
      dot: 'rgba(28,144,200,.24)',
      edge: '#e9e9e5',
      cover: '#0d628c',
      coverInk: '#fff8ee',
      plaque: '#f1d7bd',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 477, ih: 548, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 419, ih: 540, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 799, ih: 601, x: 50, y: 37, w: 71.8, lean: 4 },
        { key: 'p3', iw: 752, ih: 325, x: 50, y: 64, w: 64.8, lean: 2 },
        { key: 'p4', iw: 387, ih: 399, x: 50, y: 93, w: 51.5, lean: 16, plaque: [0.2, 0.27, 0.22, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 337, ih: 476, x: 14, top: 18, w: 18.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 196, ih: 225, x: 86, top: 22, w: 10.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.86, top: 73.68, width: 23.67, height: 13 },
    },
  },
  {
    id: 'pop-little-lamb',
    look: 'popup',
    category: 'baby',
    label: { en: 'Little Lamb', ka: 'პატარა ბატკანი' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['little', 'lamb', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f3f7f5',
    ink: '#331b0b',
    accents: ['#4a5408', '#0d8c42'],
    popup: {
      bh: 134,
      table: ['#f3f7f5', '#e2ebe6'],
      floor: '#f9f8f4',
      dot: 'rgba(28,200,100,.24)',
      edge: '#eae9e5',
      cover: '#0d8c42',
      coverInk: '#fff8ee',
      plaque: '#e5b898',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 533, ih: 568, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 575, ih: 401, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 857, ih: 484, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 817, ih: 232, x: 50, y: 64, w: 98.6, lean: 2 },
        { key: 'p4', iw: 570, ih: 352, x: 50, y: 93, w: 76, lean: 16, plaque: [0.21, 0.26, 0.2, 0.27] },
      ],
      floaters: [
        { key: 'p5', iw: 397, ih: 562, x: 14, top: 18, w: 18.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 165, ih: 168, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 32.5, top: 75.64, width: 35.47, height: 10.33 },
    },
  },
  {
    id: 'pop-twinkle-star',
    look: 'popup',
    category: 'baby',
    label: { en: 'Twinkle Star', ka: 'ციმციმა ვარსკვლავი' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['twinkle', 'star', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#e0e5ee',
    ink: '#331d0a',
    accents: ['#8c410d', '#0d408c'],
    popup: {
      bh: 134,
      table: ['#e0e5ee', '#b0bed4'],
      floor: '#f4f3f2',
      dot: 'rgba(28,98,200,.24)',
      edge: '#e5e5e3',
      cover: '#0d408c',
      coverInk: '#fff8ee',
      plaque: '#f9efe7',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 626, ih: 680, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 505, ih: 681, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 878, ih: 709, x: 50, y: 37, w: 66.9, lean: 4 },
        { key: 'p3', iw: 952, ih: 306, x: 50, y: 64, w: 87.1, lean: 2 },
        { key: 'p4', iw: 466, ih: 447, x: 50, y: 93, w: 52.1, lean: 16, plaque: [0.18, 0.19, 0.18, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 435, ih: 455, x: 14, top: 18, w: 21.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 321, ih: 352, x: 86, top: 22, w: 10.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 36.72, top: 72.91, width: 26.28, height: 14.31 },
    },
  },
  {
    id: 'pop-little-elephant',
    look: 'popup',
    category: 'baby',
    label: { en: 'Little Elephant', ka: 'პატარა სპილო' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['little', 'elephant', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f7f3f5',
    ink: '#32250c',
    accents: ['#8c540d', '#8c0d50'],
    popup: {
      bh: 134,
      table: ['#f7f3f5', '#eae2e6'],
      floor: '#faf7f4',
      dot: 'rgba(200,28,120,.24)',
      edge: '#ebe8e5',
      cover: '#8c0d50',
      coverInk: '#fff8ee',
      plaque: '#faf6ef',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 763, ih: 711, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 454, ih: 783, x: 80, y: 13, w: 34.8, lean: 6 },
        { key: 'p2', iw: 1019, ih: 679, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 902, ih: 346, x: 50, y: 64, w: 73, lean: 2 },
        { key: 'p4', iw: 554, ih: 462, x: 50, y: 93, w: 60, lean: 16, plaque: [0.15, 0.29, 0.15, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 379, ih: 587, x: 14, top: 18, w: 17.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 187, ih: 287, x: 86, top: 22, w: 8.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.4, top: 75.34, width: 33.16, height: 12.74 },
    },
  },
  {
    id: 'pop-teddy-baby',
    look: 'popup',
    category: 'baby',
    label: { en: 'Teddy Bear', ka: 'დათუნია' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['teddy', 'baby', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f3f3f5',
    ink: '#3d3d00',
    accents: ['#8c3c0d', '#8c5b0d'],
    popup: {
      bh: 134,
      table: ['#f3f3f5', '#e2e1e5'],
      floor: '#f9f7f4',
      dot: 'rgba(200,133,28,.24)',
      edge: '#eae8e5',
      cover: '#8c5b0d',
      coverInk: '#fff8ee',
      plaque: '#fffffe',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 400, ih: 633, x: 20, y: 10, w: 37.9, lean: 6 },
        { key: 'p1', iw: 597, ih: 625, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 981, ih: 607, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 870, ih: 306, x: 50, y: 64, w: 79.6, lean: 2 },
        { key: 'p4', iw: 590, ih: 425, x: 50, y: 93, w: 69.4, lean: 16, plaque: [0.14, 0.16, 0.14, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 436, ih: 656, x: 14, top: 18, w: 17.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 191, ih: 364, x: 86, top: 22, w: 8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.03, top: 72.2, width: 39.88, height: 15.71 },
    },
  },
  {
    id: 'pop-hot-air-baby',
    look: 'popup',
    category: 'baby',
    label: { en: 'Oh Baby', ka: 'ბავშვი გზაშია' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['hot', 'air', 'baby', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f2f4f3',
    ink: '#003d25',
    accents: ['#8c6b0d', '#0d8c79'],
    popup: {
      bh: 134,
      table: ['#f2f4f3', '#dee4e2'],
      floor: '#f9f7f3',
      dot: 'rgba(28,200,175,.24)',
      edge: '#eae9e5',
      cover: '#0d8c79',
      coverInk: '#fff8ee',
      plaque: '#fdfffe',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 526, ih: 756, x: 20, y: 10, w: 41.7, lean: 6 },
        { key: 'p1', iw: 376, ih: 720, x: 80, y: 13, w: 31.3, lean: 6 },
        { key: 'p2', iw: 602, ih: 792, x: 50, y: 37, w: 50, lean: 4 },
        { key: 'p3', iw: 913, ih: 287, x: 50, y: 64, w: 89.1, lean: 2 },
        { key: 'p4', iw: 473, ih: 306, x: 50, y: 93, w: 76, lean: 16, plaque: [0.15, 0.19, 0.15, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 305, ih: 366, x: 14, top: 18, w: 20.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 318, ih: 222, x: 86, top: 22, w: 13.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.19, top: 73.15, width: 41.8, height: 14.08 },
    },
  },
  {
    id: 'pop-little-duckling',
    look: 'popup',
    category: 'baby',
    label: { en: 'Little Duckling', ka: 'იხვის ჭუკი' },
    blurb: { en: 'A soft paper scene that unfolds for the little one.', ka: 'ნაზი ქაღალდის სცენა პატარასთვის, რომელიც გახსნისას იშლება.' },
    tags: ['little', 'duckling', 'pop-up', '3d', 'გასაშლელი'],
    font: 'quicksand',
    paper: '#f6f9f8',
    ink: '#353509',
    accents: ['#8c6a0d', '#0d728c'],
    popup: {
      bh: 134,
      table: ['#f6f9f8', '#e8f1ee'],
      floor: '#faf9f5',
      dot: 'rgba(28,166,200,.24)',
      edge: '#ebeae6',
      cover: '#0d728c',
      coverInk: '#fff8ee',
      plaque: '#fefefd',
      titleSize: 0.12,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 483, ih: 605, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 695, ih: 573, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 769, ih: 618, x: 50, y: 37, w: 67.2, lean: 4 },
        { key: 'p3', iw: 863, ih: 294, x: 50, y: 64, w: 82.2, lean: 2 },
        { key: 'p4', iw: 469, ih: 538, x: 50, y: 93, w: 50.6, lean: 16, plaque: [0.22, 0.24, 0.23, 0.48] },
      ],
      floaters: [
        { key: 'p5', iw: 359, ih: 577, x: 14, top: 18, w: 17.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 326, ih: 331, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.94, top: 71.05, width: 22, height: 7.91 },
    },
  },
  {
    id: 'pop-new-year',
    look: 'popup',
    category: 'holiday',
    label: { en: 'New Year\'s Eve', ka: 'საახალწლო ღამე' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['new', 'year', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cinzel',
    paper: '#e1e1e7',
    ink: '#3a2804',
    accents: ['#8c590d', '#0d6e8c'],
    popup: {
      bh: 134,
      table: ['#e1e1e7', '#b4b4c3'],
      floor: '#f4f2f0',
      dot: 'rgba(28,161,200,.24)',
      edge: '#e5e4e2',
      cover: '#0d6e8c',
      coverInk: '#fff8ee',
      plaque: '#faedd4',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 480, ih: 680, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 532, ih: 648, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 819, ih: 569, x: 50, y: 37, w: 77.7, lean: 4 },
        { key: 'p3', iw: 800, ih: 361, x: 50, y: 64, w: 62, lean: 2 },
        { key: 'p4', iw: 475, ih: 398, x: 50, y: 93, w: 59.7, lean: 16, plaque: [0.22, 0.26, 0.21, 0.24] },
      ],
      floaters: [
        { key: 'p5', iw: 453, ih: 449, x: 14, top: 18, w: 22.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 135, ih: 366, x: 86, top: 22, w: 7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 36.7, top: 74.56, width: 27.03, height: 11.56 },
    },
  },
  {
    id: 'pop-christmas-cozy',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Cozy Christmas', ka: 'საშობაო' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['christmas', 'cozy', 'pop-up', '3d', 'გასაშლელი'],
    font: 'lobster',
    paper: '#efe4db',
    ink: '#331e0a',
    accents: ['#8c140d', '#8c3d0d'],
    popup: {
      bh: 134,
      table: ['#efe4db', '#d6bba5'],
      floor: '#f8f3ed',
      dot: 'rgba(200,93,28,.24)',
      edge: '#e9e4df',
      cover: '#8c3d0d',
      coverInk: '#fff8ee',
      plaque: '#dfaa7a',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 467, ih: 684, x: 20, y: 10, w: 41, lean: 6 },
        { key: 'p1', iw: 445, ih: 786, x: 80, y: 13, w: 34, lean: 6 },
        { key: 'p2', iw: 812, ih: 520, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 1010, ih: 211, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 646, ih: 449, x: 50, y: 93, w: 71.9, lean: 16, plaque: [0.22, 0.26, 0.22, 0.24] },
      ],
      floaters: [
        { key: 'p5', iw: 447, ih: 452, x: 14, top: 18, w: 21.9, z: 12, anim: 'bob' },
        { key: 'p6', iw: 314, ih: 388, x: 86, top: 22, w: 9.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.98, top: 74.6, width: 32.04, height: 11.55 },
    },
  },
  {
    id: 'pop-easter-spring',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Easter', ka: 'აღდგომა' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['easter', 'spring', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#f7f7f5',
    ink: '#2a2a13',
    accents: ['#8c380d', '#0d648c'],
    popup: {
      bh: 134,
      table: ['#f7f7f5', '#ebeae7'],
      floor: '#faf8f4',
      dot: 'rgba(28,147,200,.24)',
      edge: '#ebe9e5',
      cover: '#0d648c',
      coverInk: '#fff8ee',
      plaque: '#fdfdfb',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 515, ih: 691, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 413, ih: 690, x: 80, y: 13, w: 35.9, lean: 6 },
        { key: 'p2', iw: 1090, ih: 759, x: 50, y: 37, w: 77.5, lean: 4 },
        { key: 'p3', iw: 1059, ih: 250, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 396, ih: 553, x: 50, y: 93, w: 46, lean: 16, plaque: [0.17, 0.16, 0.17, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 378, ih: 648, x: 14, top: 18, w: 16.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 181, ih: 222, x: 86, top: 22, w: 9.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.91, top: 66.24, width: 24.17, height: 20.74 },
    },
  },
  {
    id: 'pop-halloween-cute',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Cute Halloween', ka: 'ჰელოუინი' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['halloween', 'cute', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#eae1dc',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c490d'],
    popup: {
      bh: 134,
      table: ['#eae1dc', '#cbb4a7'],
      floor: '#f7f2ed',
      dot: 'rgba(200,110,28,.24)',
      edge: '#e8e4df',
      cover: '#8c490d',
      coverInk: '#fff8ee',
      plaque: '#b7825e',
      lightText: true,
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 471, ih: 626, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 605, ih: 736, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 716, ih: 537, x: 50, y: 37, w: 72, lean: 4 },
        { key: 'p3', iw: 868, ih: 283, x: 50, y: 64, w: 85.9, lean: 2 },
        { key: 'p4', iw: 361, ih: 448, x: 50, y: 93, w: 46.7, lean: 16, plaque: [0.21, 0.2, 0.23, 0.2] },
      ],
      floaters: [
        { key: 'p5', iw: 382, ih: 635, x: 14, top: 18, w: 17.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 278, ih: 286, x: 86, top: 22, w: 10.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 39.4, top: 70.05, width: 20.79, height: 16.43 },
    },
  },
  {
    id: 'pop-valentines',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Valentine\'s Day', ka: 'სიყვარულის დღე' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['valentines', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#faf3f7',
    ink: '#3c0f01',
    accents: ['#795f0c', '#8c0d74'],
    popup: {
      bh: 134,
      table: ['#faf3f7', '#f3e1ea'],
      floor: '#fbf7f4',
      dot: 'rgba(200,28,168,.24)',
      edge: '#ece8e6',
      cover: '#8c0d74',
      coverInk: '#fff8ee',
      plaque: '#fcece6',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 416, ih: 536, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 435, ih: 663, x: 80, y: 13, w: 39.4, lean: 6 },
        { key: 'p2', iw: 577, ih: 585, x: 50, y: 37, w: 53.3, lean: 4 },
        { key: 'p3', iw: 618, ih: 207, x: 50, y: 64, w: 83.6, lean: 2 },
        { key: 'p4', iw: 428, ih: 548, x: 50, y: 93, w: 46, lean: 16, plaque: [0.19, 0.15, 0.19, 0.46] },
      ],
      floaters: [
        { key: 'p5', iw: 371, ih: 573, x: 14, top: 18, w: 17.7, z: 12, anim: 'bob' },
        { key: 'p6', iw: 284, ih: 283, x: 86, top: 22, w: 11, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.69, top: 68.21, width: 22.52, height: 11.01 },
    },
  },
  {
    id: 'pop-rtveli-harvest',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Rtveli Harvest', ka: 'რთველი' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['rtveli', 'harvest', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cormorant',
    paper: '#f8eee1',
    ink: '#351f08',
    accents: ['#8c390d', '#8c500d'],
    popup: {
      bh: 134,
      table: ['#f8eee1', '#ecd5b3'],
      floor: '#faf6ee',
      dot: 'rgba(200,119,28,.24)',
      edge: '#ebe7e0',
      cover: '#8c500d',
      coverInk: '#fff8ee',
      plaque: '#f0d1b2',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 607, ih: 611, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 433, ih: 611, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1011, ih: 516, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 982, ih: 270, x: 50, y: 64, w: 101.8, lean: 2 },
        { key: 'p4', iw: 431, ih: 433, x: 50, y: 93, w: 53.5, lean: 16, plaque: [0.22, 0.23, 0.21, 0.22] },
      ],
      floaters: [
        { key: 'p5', iw: 406, ih: 433, x: 14, top: 18, w: 21.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 231, ih: 324, x: 86, top: 22, w: 9.3, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 38.34, top: 72.55, width: 23.71, height: 13.64 },
    },
  },
  {
    id: 'pop-tulip-day',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Spring Flowers', ka: 'გაზაფხულის ყვავილები' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['tulip', 'day', 'pop-up', '3d', 'გასაშლელი'],
    font: 'parisienne',
    paper: '#f3f4ef',
    ink: '#2d2d10',
    accents: ['#8c690d', '#8c0d30'],
    popup: {
      bh: 134,
      table: ['#f3f4ef', '#e1e2d8'],
      floor: '#f9f7f2',
      dot: 'rgba(200,28,75,.24)',
      edge: '#eae8e4',
      cover: '#8c0d30',
      coverInk: '#fff8ee',
      plaque: '#fdfdfb',
      titleSize: 0.14,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 488, ih: 689, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 570, ih: 626, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 697, ih: 672, x: 50, y: 37, w: 56, lean: 4 },
        { key: 'p3', iw: 900, ih: 321, x: 50, y: 64, w: 78.5, lean: 2 },
        { key: 'p4', iw: 486, ih: 511, x: 50, y: 93, w: 55.2, lean: 16, plaque: [0.13, 0.16, 0.34, 0.16] },
      ],
      floaters: [
        { key: 'p5', iw: 375, ih: 483, x: 14, top: 18, w: 19.4, z: 12, anim: 'bob' },
        { key: 'p6', iw: 218, ih: 322, x: 86, top: 22, w: 9.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.85, top: 68.84, width: 23.08, height: 18.64 },
    },
  },
  {
    id: 'pop-school-start',
    look: 'popup',
    category: 'holiday',
    label: { en: 'Back to School', ka: 'სკოლაში დაბრუნება' },
    blurb: { en: 'A festive paper scene that pops up in 3D.', ka: 'სადღესასწაულო ქაღალდის სცენა, რომელიც 3D-ში ამოდის.' },
    tags: ['school', 'start', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#ecf5fa',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#0d548c'],
    popup: {
      bh: 134,
      table: ['#ecf5fa', '#cfe6f1'],
      floor: '#f7f8f5',
      dot: 'rgba(28,124,200,.24)',
      edge: '#e8e9e6',
      cover: '#0d548c',
      coverInk: '#fff8ee',
      plaque: '#312e30',
      lightText: true,
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 456, ih: 605, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 518, ih: 571, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 730, ih: 602, x: 50, y: 37, w: 65.5, lean: 4 },
        { key: 'p3', iw: 858, ih: 251, x: 50, y: 64, w: 95.7, lean: 2 },
        { key: 'p4', iw: 491, ih: 447, x: 50, y: 93, w: 54.9, lean: 16, plaque: [0.2, 0.16, 0.2, 0.45] },
      ],
      floaters: [
        { key: 'p5', iw: 361, ih: 521, x: 14, top: 18, w: 18.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 227, ih: 255, x: 86, top: 22, w: 10.4, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 36.77, top: 72.14, width: 26.39, height: 9.25 },
    },
  },
  {
    id: 'pop-graduation',
    look: 'popup',
    category: 'corporate',
    label: { en: 'Graduation', ka: 'გამოსაშვები' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['graduation', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cinzel',
    paper: '#ecefe3',
    ink: '#2c2011',
    accents: ['#8c4f0d', '#728c0d'],
    popup: {
      bh: 134,
      table: ['#ecefe3', '#d0d7b9'],
      floor: '#f7f6ef',
      dot: 'rgba(165,200,28,.24)',
      edge: '#e8e7e1',
      cover: '#728c0d',
      coverInk: '#fff8ee',
      plaque: '#e9dccc',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 426, ih: 652, x: 20, y: 10, w: 39.2, lean: 6 },
        { key: 'p1', iw: 490, ih: 595, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 806, ih: 626, x: 50, y: 37, w: 69.5, lean: 4 },
        { key: 'p3', iw: 987, ih: 201, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 673, ih: 353, x: 50, y: 93, w: 76, lean: 16, plaque: [0.21, 0.32, 0.23, 0.27] },
      ],
      floaters: [
        { key: 'p5', iw: 622, ih: 524, x: 14, top: 18, w: 24, z: 12, anim: 'bob' },
        { key: 'p6', iw: 282, ih: 306, x: 86, top: 22, w: 10.6, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 32.9, top: 79.13, width: 33.3, height: 7.71 },
    },
  },
  {
    id: 'pop-city-gala',
    look: 'popup',
    category: 'corporate',
    label: { en: 'City Gala', ka: 'საღამოს გალა' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['city', 'gala', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cinzel',
    paper: '#d5d8db',
    ink: '#32240b',
    accents: ['#8c5b0d', '#0d538c'],
    popup: {
      bh: 134,
      table: ['#d5d8db', '#969da5'],
      floor: '#f1f0ed',
      dot: 'rgba(28,123,200,.24)',
      edge: '#e2e1df',
      cover: '#0d538c',
      coverInk: '#fff8ee',
      plaque: '#f6eddd',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 212, ih: 759, x: 20, y: 10, w: 24, lean: 6 },
        { key: 'p1', iw: 622, ih: 689, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 958, ih: 569, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 1010, ih: 187, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 711, ih: 407, x: 50, y: 93, w: 76, lean: 16, plaque: [0.2, 0.3, 0.2, 0.3] },
      ],
      floaters: [
        { key: 'p5', iw: 502, ih: 523, x: 14, top: 18, w: 21.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 278, ih: 148, x: 86, top: 22, w: 15, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 32.15, top: 77.68, width: 35.52, height: 7.99 },
    },
  },
  {
    id: 'pop-launch-party',
    look: 'popup',
    category: 'corporate',
    label: { en: 'Launch Party', ka: 'პრეზენტაცია' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['launch', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'orbitron',
    paper: '#d9dfec',
    ink: '#01213d',
    accents: ['#0d628c', '#0d2f8c'],
    popup: {
      bh: 134,
      table: ['#d9dfec', '#a1afcf'],
      floor: '#f2f2f1',
      dot: 'rgba(28,74,200,.24)',
      edge: '#e3e3e3',
      cover: '#0d2f8c',
      coverInk: '#fff8ee',
      plaque: '#cbe5fb',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 454, ih: 611, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 388, ih: 604, x: 80, y: 13, w: 38.5, lean: 6 },
        { key: 'p2', iw: 708, ih: 617, x: 50, y: 37, w: 62, lean: 4 },
        { key: 'p3', iw: 804, ih: 306, x: 50, y: 64, w: 73.6, lean: 2 },
        { key: 'p4', iw: 702, ih: 476, x: 50, y: 93, w: 73.7, lean: 16, plaque: [0.15, 0.18, 0.15, 0.18] },
      ],
      floaters: [
        { key: 'p5', iw: 342, ih: 554, x: 14, top: 18, w: 17.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 174, ih: 176, x: 86, top: 22, w: 10.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 29.57, top: 72.74, width: 40.74, height: 14.73 },
    },
  },
  {
    id: 'pop-office-party',
    look: 'popup',
    category: 'corporate',
    label: { en: 'Office Party', ka: 'საოფისე წვეულება' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['office', 'party', 'pop-up', '3d', 'გასაშლელი'],
    font: 'fredoka',
    paper: '#f7f6f4',
    ink: '#19241e',
    accents: ['#8c510d', '#498c0d'],
    popup: {
      bh: 134,
      table: ['#f7f6f4', '#ebe8e4'],
      floor: '#faf8f4',
      dot: 'rgba(110,200,28,.24)',
      edge: '#ebe9e5',
      cover: '#498c0d',
      coverInk: '#fff8ee',
      plaque: '#f8faf8',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 429, ih: 575, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 657, ih: 516, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 752, ih: 472, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 741, ih: 211, x: 50, y: 64, w: 98.3, lean: 2 },
        { key: 'p4', iw: 467, ih: 328, x: 50, y: 93, w: 71.2, lean: 16, plaque: [0.15, 0.19, 0.15, 0.19] },
      ],
      floaters: [
        { key: 'p5', iw: 414, ih: 500, x: 14, top: 18, w: 20, z: 12, anim: 'bob' },
        { key: 'p6', iw: 250, ih: 213, x: 86, top: 22, w: 11.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.49, top: 72.89, width: 38.9, height: 14.48 },
    },
  },
  {
    id: 'pop-retirement',
    look: 'popup',
    category: 'corporate',
    label: { en: 'Happy Retirement', ka: 'პენსიაზე გასვლა' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['retirement', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cormorant',
    paper: '#eeeae4',
    ink: '#372506',
    accents: ['#5e660a', '#8c4c0d'],
    popup: {
      bh: 134,
      table: ['#eeeae4', '#d3cbbb'],
      floor: '#f7f5ef',
      dot: 'rgba(200,114,28,.24)',
      edge: '#e9e6e1',
      cover: '#8c4c0d',
      coverInk: '#fff8ee',
      plaque: '#f8ebd5',
      titleSize: 0.13,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 660, ih: 733, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 459, ih: 624, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1069, ih: 806, x: 50, y: 37, w: 71.6, lean: 4 },
        { key: 'p3', iw: 883, ih: 369, x: 50, y: 64, w: 67, lean: 2 },
        { key: 'p4', iw: 574, ih: 583, x: 50, y: 93, w: 49.2, lean: 16, plaque: [0.12, 0.17, 0.13, 0.29] },
      ],
      floaters: [
        { key: 'p5', iw: 412, ih: 594, x: 14, top: 18, w: 18.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 394, ih: 241, x: 86, top: 22, w: 14.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 35.38, top: 72.43, width: 29.04, height: 12.71 },
    },
  },
  {
    id: 'pop-team-summit',
    look: 'popup',
    category: 'corporate',
    label: { en: 'Team Summit', ka: 'გუნდური შეხვედრა' },
    blurb: { en: 'A paper scene that unfolds for your event.', ka: 'ქაღალდის სცენა, რომელიც თქვენი ღონისძიებისთვის იშლება.' },
    tags: ['team', 'summit', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bebas',
    paper: '#f1efee',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c0d1e'],
    popup: {
      bh: 134,
      table: ['#f1efee', '#dbd6d6'],
      floor: '#f8f6f2',
      dot: 'rgba(200,28,51,.24)',
      edge: '#e9e7e3',
      cover: '#8c0d1e',
      coverInk: '#fff8ee',
      plaque: '#cf905f',
      lightText: true,
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 393, ih: 578, x: 20, y: 10, w: 40.8, lean: 6 },
        { key: 'p1', iw: 661, ih: 422, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 838, ih: 613, x: 50, y: 37, w: 73.8, lean: 4 },
        { key: 'p3', iw: 820, ih: 313, x: 50, y: 64, w: 73.4, lean: 2 },
        { key: 'p4', iw: 560, ih: 462, x: 50, y: 93, w: 60.6, lean: 16, plaque: [0.15, 0.22, 0.13, 0.21] },
      ],
      floaters: [
        { key: 'p5', iw: 416, ih: 425, x: 14, top: 18, w: 21.8, z: 12, anim: 'bob' },
        { key: 'p6', iw: 213, ih: 284, x: 86, top: 22, w: 9.5, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.47, top: 73.64, width: 34.35, height: 13.17 },
    },
  },
  {
    id: 'pop-garden-bbq',
    look: 'popup',
    category: 'outdoor',
    label: { en: 'Garden BBQ', ka: 'მწვადი ბაღში' },
    blurb: { en: 'An outdoor scene that pops up from the card.', ka: 'ბუნების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['garden', 'bbq', 'pop-up', '3d', 'გასაშლელი'],
    font: 'luckiest-guy',
    paper: '#efeadc',
    ink: '#341f09',
    accents: ['#66370a', '#8c360d'],
    popup: {
      bh: 134,
      table: ['#efeadc', '#d6c9a8'],
      floor: '#f8f4ed',
      dot: 'rgba(200,84,28,.24)',
      edge: '#e9e6df',
      cover: '#8c360d',
      coverInk: '#fff8ee',
      plaque: '#dfa86f',
      titleSize: 0.12,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 623, ih: 506, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 597, ih: 702, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 938, ih: 684, x: 50, y: 37, w: 74.1, lean: 4 },
        { key: 'p3', iw: 929, ih: 231, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 639, ih: 438, x: 50, y: 93, w: 72.9, lean: 16, plaque: [0.17, 0.21, 0.17, 0.22] },
      ],
      floaters: [
        { key: 'p5', iw: 360, ih: 524, x: 14, top: 18, w: 18.2, z: 12, anim: 'bob' },
        { key: 'p6', iw: 194, ih: 384, x: 86, top: 22, w: 7.8, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 30.96, top: 73.39, width: 37.96, height: 13.31 },
    },
  },
  {
    id: 'pop-park-picnic',
    look: 'popup',
    category: 'outdoor',
    label: { en: 'Park Picnic', ka: 'პიკნიკი პარკში' },
    blurb: { en: 'An outdoor scene that pops up from the card.', ka: 'ბუნების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['park', 'picnic', 'pop-up', '3d', 'გასაშლელი'],
    font: 'chewy',
    paper: '#f2f6f5',
    ink: '#382405',
    accents: ['#8c560d', '#0d5c8c'],
    popup: {
      bh: 134,
      table: ['#f2f6f5', '#dfe9e5'],
      floor: '#f9f8f4',
      dot: 'rgba(28,135,200,.24)',
      edge: '#eae9e5',
      cover: '#0d5c8c',
      coverInk: '#fff8ee',
      plaque: '#faedd9',
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 535, ih: 656, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 566, ih: 619, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 961, ih: 509, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 744, ih: 261, x: 50, y: 64, w: 79.8, lean: 2 },
        { key: 'p4', iw: 529, ih: 582, x: 50, y: 93, w: 46, lean: 16, plaque: [0.16, 0.12, 0.17, 0.54] },
      ],
      floaters: [
        { key: 'p5', iw: 392, ih: 615, x: 14, top: 18, w: 17.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 254, ih: 244, x: 86, top: 22, w: 11.2, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 37.72, top: 70.96, width: 24.49, height: 8.1 },
    },
  },
  {
    id: 'pop-starry-camp',
    look: 'popup',
    category: 'outdoor',
    label: { en: 'Starry Camp', ka: 'ბანაკი ვარსკვლავების ქვეშ' },
    blurb: { en: 'An outdoor scene that pops up from the card.', ka: 'ბუნების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['starry', 'camp', 'pop-up', '3d', 'გასაშლელი'],
    font: 'bebas',
    paper: '#d6dae4',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#0d418c'],
    popup: {
      bh: 134,
      table: ['#d6dae4', '#99a4bd'],
      floor: '#f1f0ef',
      dot: 'rgba(28,99,200,.24)',
      edge: '#e3e2e1',
      cover: '#0d418c',
      coverInk: '#fff8ee',
      plaque: '#9e654a',
      lightText: true,
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 648, ih: 553, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 425, ih: 669, x: 80, y: 13, w: 38.1, lean: 6 },
        { key: 'p2', iw: 975, ih: 542, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 817, ih: 251, x: 50, y: 64, w: 91.1, lean: 2 },
        { key: 'p4', iw: 616, ih: 498, x: 50, y: 93, w: 61.8, lean: 16, plaque: [0.17, 0.35, 0.17, 0.18] },
      ],
      floaters: [
        { key: 'p5', iw: 392, ih: 428, x: 14, top: 18, w: 21.1, z: 12, anim: 'bob' },
        { key: 'p6', iw: 156, ih: 373, x: 86, top: 22, w: 7.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 33.91, top: 76.64, width: 32.09, height: 10.92 },
    },
  },
  {
    id: 'pop-beach-bonfire',
    look: 'popup',
    category: 'outdoor',
    label: { en: 'Beach Bonfire', ka: 'კოცონი სანაპიროზე' },
    blurb: { en: 'An outdoor scene that pops up from the card.', ka: 'ბუნების სცენა, რომელიც ბარათიდან ამოდის.' },
    tags: ['beach', 'bonfire', 'pop-up', '3d', 'გასაშლელი'],
    font: 'lobster',
    paper: '#f3ede6',
    ink: '#fff3e0',
    accents: ['#ffe1a3', '#8c2a0d'],
    popup: {
      bh: 134,
      table: ['#f3ede6', '#e1d2c2'],
      floor: '#f9f5f0',
      dot: 'rgba(200,68,28,.24)',
      edge: '#eae7e1',
      cover: '#8c2a0d',
      coverInk: '#fff8ee',
      plaque: '#c99970',
      lightText: true,
      titleSize: 0.13,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 580, ih: 698, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 534, ih: 700, x: 80, y: 13, w: 42, lean: 6 },
        { key: 'p2', iw: 1072, ih: 576, x: 50, y: 37, w: 80, lean: 4 },
        { key: 'p3', iw: 848, ih: 182, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 599, ih: 574, x: 50, y: 93, w: 52.2, lean: 16, plaque: [0.12, 0.17, 0.14, 0.4] },
      ],
      floaters: [
        { key: 'p5', iw: 355, ih: 503, x: 14, top: 18, w: 18.5, z: 12, anim: 'bob' },
        { key: 'p6', iw: 215, ih: 185, x: 86, top: 22, w: 11.9, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 34.45, top: 72.29, width: 30.37, height: 10.18 },
    },
  },
  {
    id: 'pop-golden-anniversary',
    look: 'popup',
    category: 'elegant',
    label: { en: 'Golden Anniversary', ka: 'ოქროს იუბილე' },
    blurb: { en: 'An elegant paper scene that unfolds in 3D.', ka: 'ელეგანტური ქაღალდის სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['golden', 'anniversary', 'pop-up', '3d', 'გასაშლელი'],
    font: 'great-vibes',
    paper: '#f4f1ed',
    ink: '#261c17',
    accents: ['#8c540d', '#8c590d'],
    popup: {
      bh: 134,
      table: ['#f4f1ed', '#e3ddd2'],
      floor: '#f9f7f2',
      dot: 'rgba(200,131,28,.24)',
      edge: '#eae8e3',
      cover: '#8c590d',
      coverInk: '#fff8ee',
      plaque: '#f0eae8',
      titleSize: 0.15,
      titleWeight: 400,
      layers: [
        { key: 'p0', iw: 442, ih: 797, x: 20, y: 10, w: 33.3, lean: 6 },
        { key: 'p1', iw: 564, ih: 827, x: 80, y: 13, w: 40.9, lean: 6 },
        { key: 'p2', iw: 982, ih: 739, x: 50, y: 37, w: 71.8, lean: 4 },
        { key: 'p3', iw: 897, ih: 240, x: 50, y: 64, w: 104, lean: 2 },
        { key: 'p4', iw: 470, ih: 629, x: 50, y: 93, w: 46, lean: 16, plaque: [0.24, 0.27, 0.25, 0.24] },
      ],
      floaters: [
        { key: 'p5', iw: 340, ih: 617, x: 14, top: 18, w: 16.3, z: 12, anim: 'bob' },
        { key: 'p6', iw: 291, ih: 177, x: 86, top: 22, w: 14.1, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 40.7, top: 70.8, width: 18.52, height: 13.98 },
    },
  },
  {
    id: 'pop-wine-evening',
    look: 'popup',
    category: 'elegant',
    label: { en: 'Wine Evening', ka: 'ღვინის საღამო' },
    blurb: { en: 'An elegant paper scene that unfolds in 3D.', ka: 'ელეგანტური ქაღალდის სცენა, რომელიც 3D-ში იშლება.' },
    tags: ['wine', 'evening', 'pop-up', '3d', 'გასაშლელი'],
    font: 'cinzel',
    paper: '#ede2da',
    ink: '#32240b',
    accents: ['#8c580d', '#8c3e0d'],
    popup: {
      bh: 134,
      table: ['#ede2da', '#d2b6a4'],
      floor: '#f7f2ed',
      dot: 'rgba(200,94,28,.24)',
      edge: '#e8e4de',
      cover: '#8c3e0d',
      coverInk: '#fff8ee',
      plaque: '#f5e9d7',
      titleSize: 0.1,
      titleWeight: 700,
      layers: [
        { key: 'p0', iw: 716, ih: 645, x: 20, y: 10, w: 42, lean: 6 },
        { key: 'p1', iw: 252, ih: 760, x: 80, y: 13, w: 24, lean: 6 },
        { key: 'p2', iw: 841, ih: 713, x: 50, y: 37, w: 63.7, lean: 4 },
        { key: 'p3', iw: 911, ih: 297, x: 50, y: 64, w: 85.9, lean: 2 },
        { key: 'p4', iw: 429, ih: 431, x: 50, y: 93, w: 57.7, lean: 16, plaque: [0.28, 0.36, 0.28, 0.38] },
      ],
      floaters: [
        { key: 'p5', iw: 331, ih: 464, x: 14, top: 18, w: 18.6, z: 12, anim: 'bob' },
        { key: 'p6', iw: 158, ih: 325, x: 86, top: 22, w: 7.7, z: 18, anim: 'glide' },
      ],
      thumbText: { left: 39.87, top: 74.6, width: 20.17, height: 6.92 },
    },
  },
]
